Vue.component('calculator-dropdown', {
        props: {
            modelValue: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            list: {
                type: Array,
                required: true
            },
        },

        emits: ['update:modelValue'],

        data: function () {
            return {
                currentItem: null,
                isDropdownOpen: false
            }
        },

        methods: {
            selectDropdownItem(item) {
                this.currentItem = item
                this.$emit('update:modelValue', item)
                this._closeList()
            },

            getDropdownParentClasses() {
                return {
                    'open': this.isDropdownOpen
                }
            },

            onOpenRequest() {
                if (!this.showDropdownContent()) {
                    return
                }

                if (this.isDropdownOpen) {
                    this._closeList()
                }
                else {
                    this._openList()
                }
            },

            showDropdownContent() {
                return this.list && this.list.length > 1
            },

            _closeList() {
                this.isDropdownOpen = false
                $(this.$refs.list).stop().slideUp('fast')
            },

            _openList() {
                this.isDropdownOpen = true
                $(this.$refs.list).stop().slideDown('fast')
            }
        },

        computed: {
            currentItemText() {
                if (!this.currentItem) {
                    return ''
                }

                return this.currentItem.text
            },

            currentItemId() {
                if (!this.currentItem) {
                    return ''
                }

                return this.currentItem.id
            }
        },

        mounted() {
            this.currentItem = this.modelValue
        },

        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }
                this._closeList()
            })
        }
    ,
template: `
    <div class="calculator__calculate-item">
        <div class="interest-rate__filters">
            <div class="interest-rate__filters-item"
                 :class="getDropdownParentClasses()">
                <a href="" class="interest-rate__filters-item-trigger"
                   @click.prevent="onOpenRequest()">
                    <div class="interest-rate__filters-item-trigger-text">
                        <span class="interest-rate__filters-item-trigger-label">{{ title }}</span>
                        <span class="interest-rate__filters-item-trigger-value">{{ currentItemText }}</span>
                    </div>
                    <svg v-show="showDropdownContent()" class="interest-rate__filters-item-trigger-icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                    </svg>
                </a>
                <div class="interest-rate__filters-item-results" style="display: none;"
                     v-show="showDropdownContent()"
                     ref="list">
                    <div class="interest-rate__filters-item-results-content">
                        <a href="" class="interest-rate__filters-item-results-item"
                           v-for="listItem in list"
                           v-show="listItem.id != currentItemId"
                           @click.prevent="selectDropdownItem(listItem)">
                            {{ listItem.text }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('calculator-slider', {
        props: {
            title: {
                type: String,
                required: true
            },

            minValue: {
                type: Number,
                required: true
            },

            maxValue: {
                type: Number,
                required: true
            },

            startValue: {
                type: Number,
                required: true
            },

            measure: {
                type: String,
                required: false
            },

            minPrefix: {
                type: String,
                required: false
            },

            maxPrefix: {
                type: String,
                required: false
            },

            dropdownList: {
                type: Array,
                required: false
            },

            hideSliderControls: {
                type: Boolean,
                default: false,
                required: false
            }
        },

        emits: ['update:modelValue', 'update:measure'],

        data: function () {
            return {
                measureValue: null,
                currentValue: null,
                currentValueIsValid: true,
                isDropdownOpen: false,
                inputChangeTimeoutId: null,
                inputChangeTimeoutWaitMs: 700
            }
        },

        methods: {
            getRootClasses() {
                return {
                    'has-error': !this.currentValueIsValid
                }
            },

            showDropdownList() {
                const show = this.dropdownList && this.dropdownList.length
                return show
            },

            formatNumber(val) {
                const formattedVal = TextFormattingService.formatCalculatorInteger(val)
                return formattedVal
            },

            selectDropdownItem(measureVal) {
                this.measureValue = measureVal
                this.$emit('update:measure', measureVal)
                this._closeList()
            },

            getDropdownParentClasses() {
                return {
                    'open': this.isDropdownOpen
                }
            },

            onOpenRequest() {
                if (!this.showDropdownContent()) {
                    return
                }

                if (this.isDropdownOpen) {
                    this._closeList()
                }
                else {
                    this._openList()
                }
            },

            onInputChanged() {
                if (this.inputChangeTimeoutId) {
                    clearTimeout(this.inputChangeTimeoutId)
                }

                this.inputChangeTimeoutId = setTimeout(() => {
                    if (this.currentValue > this.maxValue) {
                        this.currentValue = this.maxValue
                    }

                    this.currentValueIsValid = true
                    if (this.currentValue < this.minValue) {
                        this.currentValueIsValid = false
                        return
                        //this.currentValue = this.minValue
                    }

                    const slider = this.$refs.slider.noUiSlider

                    slider.setHandle(0, this.currentValue, false, false);
                    this._closeList()
                }, this.inputChangeTimeoutWaitMs)
            },

            showDropdownContent() {
                return this.dropdownList && this.dropdownList.length > 1
            },

            _initializeSlider() {
                const sliderElement = this.$refs.slider

                const numericOptions = this._generateNumericOptions()
                const sliderOptions = {
                    ...numericOptions,
                    connect: [true, false],
                    pips: {
                        mode: 'count',
                        values: 9,
                        density: 9
                    }
                }
                noUiSlider.create(sliderElement, sliderOptions)

                sliderElement.noUiSlider.on('update', () => {
                    this._updatePipClasses()
                })
            },

            _updateSliderOptions() {
                const sliderElement = this.$refs.slider

                const numericOptions = this._generateNumericOptions()
                sliderElement.noUiSlider.updateOptions(numericOptions);
            },

            _generateNumericOptions() {
                const start = this.startValue || 0;
                const min = (this.minValue === Infinity || this.minValue === -Infinity)
                    ? 0
                    : (this.minValue || 0);
                const max = (this.maxValue === Infinity || this.maxValue === -Infinity)
                    ? 1
                    : (this.maxValue || min + 1);

                var numericOptions = {
                    start: [start],
                    range: {
                        min: min,
                        max: max
                    }
                }
                return numericOptions;
            },

            _updatePipClasses() {
                const sliderElement = this.$refs.slider

                const handleValue = sliderElement.noUiSlider.get()
                const allPips = sliderElement.querySelectorAll('.noUi-marker')

                allPips.forEach(function (pip) {
                    const pipValue = parseFloat(pip.nextElementSibling.getAttribute('data-value'))
                    const isActive = pipValue < handleValue
                    pip.classList.toggle('active-pip', isActive)
                })

                this.currentValue = parseInt(handleValue)

                this.$emit('update:modelValue', this.currentValue)

                this._closeList()
            },

            _closeList() {
                this.isDropdownOpen = false
                $(this.$refs.list).stop().slideUp('fast')
            },

            _openList() {
                this.isDropdownOpen = true
                $(this.$refs.list).stop().slideDown('fast')
            }
        },

        watch: {

            minValue(newValue, oldValue) {
                this._updateSliderOptions()
            },

            maxValue(newValue, oldValue) {
                this._updateSliderOptions()
            },

            startValue(newValue, oldValue) {
                this._updateSliderOptions()
            }
        },

        computed: {
            showInputMinHint() {
                const show = this.hideSliderControls && this.minValue > 0
                return show
            }
        },

        mounted() {
            this.measureValue = this.measure
            this.currentValue = this.startValue

            this._initializeSlider()
        },

        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }
                this._closeList()
            })
        }
    ,
template: `
    <div class="calculator__calculate-item" :class="getRootClasses()">
        <div class="calculator__calculate-item-head">
            <h4 class="calculator__calculate-item-title">{{ title }}</h4>
            
            <div class="calculator__calculate-item-field">
                <input type="text" class="calculator__calculate-item-input" placeholder=""
                       v-model="currentValue"
                       @input="onInputChanged()">

                <div class="calculator__calculate-item-dropdown"
                     :class="getDropdownParentClasses()"
                     v-if="showDropdownList()">

                    <a href="" class="calculator__calculate-item-dropdown-trigger"
                       @click.prevent="onOpenRequest()">
                        <span class="calculator__calculate-item-dropdown-trigger-text">{{ measureValue }}</span>
                        <svg class="calculator__calculate-item-dropdown-trigger-icon"
                             v-show="showDropdownContent()">
                            <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                        </svg>
                    </a>

                    <div class="calculator__calculate-item-dropdown-results"
                         v-show="showDropdownContent()"
                         ref="list">
                        <div class="calculator__calculate-item-dropdown-results-content">
                            <a href="" class="calculator__calculate-item-dropdown-results-item"
                               v-for="listElem in dropdownList"
                               v-show="listElem != measureValue"
                               @click.prevent="selectDropdownItem(listElem)">
                                <span class="calculator__calculate-item-dropdown-results-item-text">{{ listElem }}</span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
        <div class="calculator__calculate-minmax calculator__calculate-minmax--single-child" v-show="showInputMinHint">
            <p class="calculator__calculate-minmax-item">{{ minPrefix }} <span>{{ formatNumber(minValue) }}{{ measureValue }}</span></p>
        </div>

        <div ref="slider" v-show="!hideSliderControls"></div>

        <div class="calculator__calculate-minmax" v-show="!hideSliderControls">
            <p class="calculator__calculate-minmax-item">{{ minPrefix }} <span>{{ formatNumber(minValue) }}{{ measureValue }}</span></p>
            <p class="calculator__calculate-minmax-item">{{ maxPrefix }} <span>{{ formatNumber(maxValue) }}{{ measureValue }}</span></p>
        </div>

    </div>
`
});
Vue.component('currency-selector', {
        props: {
            currencies: {
                type: Array,
                required: true
            },
            modelValue: {
                type: String,
                required: true
            }
        },

        emits: ['update:modelValue'],

        data: function () {
            return {
                isOpen: false
            }
        },

        methods: {
            getFlagUrl(currency) {
                const url = '~/m/u/currencies/' + currency + '.png'
                return url
            },

            getRootClasses() {
                return {
                    'open': this.isOpen
                }
            },

            onOpenRequest() {
                if (this.isOpen) {
                    this._closeList()
                }
                else {
                    this._openList()
                }
            },

            selectCurrency(currency) {
                this.$emit('update:modelValue', currency)
                this._closeList()
            },

            _closeList() {
                this.isOpen = false
                $(this.$refs.list).stop().slideUp('fast')
            },

            _openList() {
                this.isOpen = true
                $(this.$refs.list).stop().slideDown('fast')
            }
        },

        mounted() {
        },

        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }
                this._closeList()
            })
        }
    ,
template: `
    <div class="currencies-block__currencies"
         :class="getRootClasses()">
        <a href="" class="currencies-block__currencies-trigger"
           @click.prevent="onOpenRequest()">

            <div class="currencies-block__currencies-item">
                <div class="currencies-block__currencies-flag">
                    <img :src="getFlagUrl(modelValue )" alt="" />
                </div>
                <span class="currencies-block__currencies-name">{{ modelValue }}</span>
            </div>

            <svg class="currencies-block__currencies-icon">
                <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
            </svg>
        </a>

        <div class="currencies-block__currencies-results"
             ref="list">

            <div class="currencies-block__currencies-list">

                <a href="" class="currencies-block__currencies-item"
                   v-for="currency in currencies"
                   v-show="currency != modelValue"
                   @click.prevent="selectCurrency(currency)">

                    <div class="currencies-block__currencies-flag">
                        <img :src="getFlagUrl(currency)" alt="" />
                    </div>

                    <span class="currencies-block__currencies-name">{{ currency }}</span>
                </a>
            </div>
        </div>
    </div>
`
});
Vue.component('formcontrol-file-upload', {
        props: {
            field: Object,
            submitted: Boolean,
        },
        data: function () {
            return {
                fileMaxSize: 10 * 1024 * 1024,
                fileList: [],
                //fileListForValue: [],
                filesError: false,
                filesErrorMessage: '',
            };
        },

        methods: {
            validateValue() {
                var _this = this;
                _this.field.valid = true;
                _this.field.message = '';

                if ((_this.field.value == null || _this.field.value.length == 0) && _this.field.mandatory) {
                    _this.field.valid = false;
                    _this.field.message = $phrase('general-fillthefield');
                } else if (_this.isFileWithErrorInArray()) {
                    _this.field.valid = false;
                    _this.field.message = $phrase('vacancyform_fileuploader-filesizelimit');
                } else {
                    _this.field.valid = true;
                    _this.field.message = '';
                }
            },
            isFileWithErrorInArray() {
                return this.fileList.filter(file => file.hasError).length > 0;
            },
            dragOver(event) {
                var _this = this;
                event.dataTransfer.dropEffect = 'copy'
                const files = Array.from(event.dataTransfer.files)

            },

            dropFiles(event) {
                var _this = this;
                const files = Array
                    .from(event.dataTransfer.files)

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    _this.processFile(_this, file);
                }
            },

            selectFiles() {
                this.$refs.fileInput.click()
            },
            removeFile(file) {
                var _this = this;
                let fileIndex = _this.fileList.indexOf(file);
                _this.fileList.splice(fileIndex, 1);

                _this.field.value = _this.fileList;
                _this.validateValue();
            },
            processSelectedFiles(event) {
                var _this = this;

                const files = Array
                    .from(event.target.files)

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    _this.processFile(_this, file);
                }
            },

            getFileSizeInMB(size) {
                return (size / 1024 / 1024).toFixed(2) + 'MB';
            },

            processFile(_this, file) {
                file.hasError = false;
                file.errorMessage = '';

                if (file.size > _this.fileMaxSize) {
                    file.hasError = true;
                    //file.errorMessage = 'file is too big';
                }

                _this.fileList.push(file);

                _this.field.value = _this.fileList.filter(file => !file.hasError);
                _this.validateValue();
            },
        },

        mounted() {
        },
        watch: {
            submitted(val) {
                if (val) {
                    this.validateValue();
                }
            }
        }
    ,
template: `
    <div class="form-group form-group--fw"
         :class="{'has-error' : !field.valid && submitted}">
        <div class="form-group__content">
            <input type="file" ref="fileInput" @change="processSelectedFiles" style="display: none;" multiple>
            <div class="custom-upload"
                 @dragover.prevent="dragOver"
                 @drop.prevent="dropFiles"
                 @click.prevent="selectFiles">
                <div class="custom-upload__content">
                    <svg class="custom-upload__icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-upload"></use>
                    </svg>
                    <div class="custom-upload__text">
                        <span class="custom-upload__title">{{$phrase('vacancyform_fileuploader-selectfileanddrophere')}}</span>
                        <span class="custom-upload__subtitle">{{$phrase('vacancyform_fileuploader-fileextensions')}}</span>
                    </div>
                    <label for="custom-upload" class="custom-upload__label">
                        <span class="custom-upload__label-text">{{$phrase('vacancyform_fileuploader-selectfile')}}</span>
                    </label>
                </div>
            </div>
            <div class="custom-upload-list" v-if="fileList.length > 0">
                <div class="custom-upload-list__item" v-for="(file, index) in fileList" :key="index"
                     :class="{'has-error' : file.hasError }">
                    <svg class="custom-upload-list__icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-image"></use>
                    </svg>
                    <span class="custom-upload-list__item-title">{{file.name}}</span>
                    <span class="custom-upload-list__item-property">{{getFileSizeInMB(file.size)}}</span>
                    <a href="" class="custom-upload-list__item-delete" @click.prevent="removeFile(file)">
                        <svg class="custom-upload-list__item-delete-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </a>
                    <!--<i v-if="file.hasError">{{file.errorMessage}}</i>-->
                </div>
            </div>
            <p v-if="!field.valid" class="form__error">{{ field.message }}</p>
        </div>
    </div>
`
});
Vue.component('formcontrol-number-input', {
        props: {
            field: Object,
            submitted: Boolean,
        },

        data: function () {
            return {
            }
        },

        methods: {
            validateValue() {
                var _this = this;

                var regex = null;
                if (_this.field.regex != null && _this.field.regex != '' && _this.field.mandatory) {
                    regex = new RegExp(_this.field.regex);
                }

                if (_this.field.mandatory && (_this.field.value == null || _this.field.value == '' || !_this.field.value.length)) {
                    _this.field.valid = false;
                    _this.field.message = 'შეავსეთ ველი';
                    return;
                } else if (regex != null && !regex.test(_this.field.value)) {
                    _this.field.valid = false;
                    _this.field.message = 'არასწორი ფორმატი';
                    return;
                } else {
                    _this.field.valid = true;
                    _this.field.message = '';
                    return;
                }


                //if ((!_this.field.value || !_this.field.value.length) && _this.field.mandatory) {
                //    _this.field.valid = false;
                //    _this.field.message = 'შეავსეთ ველი';
                //} else {
                //    _this.field.valid = true;
                //    _this.field.message = '';
                //}
            },

            updateValue(value) {
                var _this = this;
                _this.field.value = value;
                if (_this.submitted) {
                    _this.validateValue();
                }
            },

            allowNumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;

                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 43) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

        },

        mounted() {
        },
        watch: {
            submitted(val) {
                if (val) {
                    this.validateValue();
                }
            }
        }
    ,
template: `
    <div class="form-group"
         :class="{'has-error' : !field.valid && submitted}">
        <div class="form-group__content">
            <input type="text"
                   class="form__field"
                   :aria-label="field.title"
                   :placeholder="field.title"
                   @input="updateValue($event.target.value)"
                   v-on:keypress="allowNumbersOnly">
            <label for="" class="form__label">{{field.title}}</label>
        </div>
        <p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>
    </div>
`
});
Vue.component('formcontrol-recaptcha', {
        props: {
            field: Object,
        },

        data: function () {
            return {

            }
        },

        methods: {
            
        },
        mounted() {
        },
        watch: {
            
        }
    ,
template: `
    <div class="form-group form-group--fw">
        <div class="form-group__content">
            <div class="recaptcha">
                <p class="recaptcha__text" v-html="field.title"></p>
            </div>
        </div>
    </div>
`
});
Vue.component('formcontrol-select', {
        props: {
            field: Object,
            submitted: Boolean,
            relatedField: Object
        },

        data: function () {
            return {
                isOpen: false,
            }
        },

        methods: {
            showItem(item) {
                if (this.relatedField == null) {
                    return true;
                } else {
                    return item != null && item.visible != null ? item.visible : false;
                }
            },
            filterList() {
                var _this = this;

                if (_this.relatedField != null) {
                    _this.field.list.forEach(item => {
                        item.visible = false;
                    });

                    if (_this.relatedField.value != null && _this.relatedField.value.id != null) {

                        var selectedRelatedFieldValue = _this.relatedField.value.id;

                        _this.field.list.forEach(item => {
                            if (item.relationId == selectedRelatedFieldValue) {
                                item.visible = true;
                            }
                        });
                    }
                }
            },
            validateValue() {
                var _this = this;

                if ((!_this.field.value || _this.field.value?.title == null || _this.field.value?.title == undefined) && _this.field.mandatory) {
                    _this.field.valid = false;
                    _this.field.message = 'შეავსეთ ველი';
                } else {
                    _this.field.valid = true;
                    _this.field.message = '';
                }
            },

            updateValue(value) {
                var _this = this;

                _this.field.value = value;
                _this.validateValue();
                _this._closeList()
            },

            onOpenRequest() {
                if (this.isOpen) {
                    this._closeList()
                }
                else {
                    this.filterList()
                    this._openList()
                }
            },

            _closeList() {
                this.isOpen = false
                $(this.$refs.list).stop().slideUp('fast')
            },

            _openList() {
                this.isOpen = true
                $(this.$refs.list).stop().slideDown('fast')
            }
        },

        mounted() {
        },
        watch: {
            'relatedField.value': function (newValue, oldValue) {
                if (oldValue != newValue) {
                    this.field.value = {};
                    this.validateValue();
                }
            },
            submitted(val) {
                if (val) {
                    this.validateValue();
                }
            }

        },
        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }
                this._closeList()
            })
        }
    ,
template: `
    <div class="form-group"
         :class="{'has-error' : !field.valid && submitted}">

        <div class="form-group__content">
            <div class="form__dropdown" :class="{'open': isOpen}">
                <a href="" class="form__dropdown-trigger " @click.prevent="onOpenRequest()">
                    <div class="form__dropdown-trigger-text">
                        <span class="form__dropdown-trigger-field" v-if="field.value != null && field.value.title != null">{{field.value.title}}</span>
                        <span class="form__dropdown-trigger-label">{{field.title}}</span>
                    </div>
                    <svg class="form__dropdown-trigger-icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                    </svg>
                </a>
                <div class="form__dropdown-results" ref="list">
                    <div class="form__dropdown-results-content">
                        <a href="" class="form__dropdown-results-item" :data-id="item.id" v-for="item in field.list" v-show="showItem(item)" @click.prevent="updateValue(item)">
                            {{item.title}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>
    </div>

`
});
Vue.component('formcontrol-text-input', {
        props: {
            field: Object,
            submitted: Boolean,
        },

        data: function () {
            return {

            }
        },

        methods: {
            validateValue() {
                var _this = this;

                var regex = null;
                if (_this.field.regex != null && _this.field.regex != '' && _this.field.mandatory) {
                    regex = new RegExp(_this.field.regex);
                }

                if (_this.field.mandatory && (_this.field.value == null || _this.field.value == '' || !_this.field.value.length)) {
                    _this.field.valid = false;
                    _this.field.message = 'შეავსეთ ველი';
                    return;
                } else if (regex != null && !regex.test(_this.field.value)) {
                    _this.field.valid = false;
                    _this.field.message = 'არასწორი ფორმატი';
                    return;
                } else {
                    _this.field.valid = true;
                    _this.field.message = '';
                    return;
                }
            },
            updateValue(value) {
                var _this = this;
                _this.field.value = value;
                if (_this.submitted) {
                    _this.validateValue();
                }
            }
        },
        mounted() {
        },
        watch: {
            submitted(val) {
                if (val) {
                    this.validateValue();
                }
            }
        }
    ,
template: `
    <div class="form-group"
         :class="{'has-error' : !field.valid && submitted}">
        <div class="form-group__content">
            <input type="text"
                   class="form__field"
                   :aria-label="field.title"
                   :placeholder="field.title"
                   @input="updateValue($event.target.value)">
            <label for="" class="form__label">{{field.title}}</label>
        </div>

        <p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>
    </div>
`
});
Vue.component('formcontrol-textarea-input', {
        props: {
            field: Object,
            submitted: Boolean,
        },

        data: function () {
            return {

            }
        },

        methods: {
            validateValue() {
                var _this = this;

                var regex = null;
                if (_this.field.regex != null && _this.field.regex != '' && _this.field.mandatory) {
                    regex = new RegExp(_this.field.regex);
                }

                if (_this.field.mandatory && (_this.field.value == null || _this.field.value == '' || !_this.field.value.length)) {
                    _this.field.valid = false;
                    _this.field.message = 'შეავსეთ ველი';
                    return;
                } else if (regex != null && !regex.test(_this.field.value)) {
                    _this.field.valid = false;
                    _this.field.message = 'არასწორი ფორმატი';
                    return;
                } else {
                    _this.field.valid = true;
                    _this.field.message = '';
                    return;
                }
            },

            updateValue(value) {
                var _this = this;
                _this.field.value = value;
                if (_this.submitted) {
                    _this.validateValue();
                }
            }
        },

        mounted() {
        },
        watch: {
            submitted(val) {
                if (val) {
                    this.validateValue();
                }
            }
        }
    ,
template: `
    <div class="form-group form-group--fw"
         :class="{'has-error' : !field.valid && submitted}">
        <div class="form-group__content">
            <textarea class="form__field form__field--textarea"
                      :aria-label="field.title"
                      :placeholder="field.title"
                      @input="updateValue($event.target.value)"></textarea>
            <label for="" class="form__label">{{field.title}}</label>
        </div>
        <p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>
    </div>
`
});
Vue.component('svg-icon', {
        props: ['icon'],
        data: function () {
            return {
                baseUrl: window._data.baseUrl
            };
        },
        methods: {
            getIconUrl: function () {
                return this.baseUrl + 'm/i/icons.svg#' + this.icon;
            }
        },
        mounted() {
        }
    ,
template: `
    <svg v-once><use v-bind="{\'xlink:href\' : getIconUrl()}" /></svg>
`
});
Vue.component('branches', {
        props: {},
        data: function () {
            return {
                locations: [],
                types: [],
                pins: [],
                filter: {
                    showMap: false,
                    selectedLocation: '',
                    selectedTypes: [],
                    filterBy24: false,
                    nearMe: false,
                    keyword: ''
                },
                currentLocation: {
                    lat: null,
                    lng: null
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
            };
        },
        methods: {
            getPageTitle() {
                return window.currentPageTitle;
            },
            toggleMap(show) {
                this.filter.showMap = show;
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            },

            selectLocation(location) {
                var _this = this;
                _this.filter.selectedLocation = location;
                $('.hero-search__filter-dropdown').removeClass('open');
                $('.js-results').hide();
                var newUrl = updateSingleValueQueryParam('location', location.Id);
                history.replaceState({}, null, newUrl);
                _this.filterPins();
            },

            initMap() {
                var _this = this;
                var firstPin = _this.pins[0];
                var lat = 41.7151377;
                var lng = 44.827096;
                if (firstPin != null) {
                    var lat = firstPin.Latitude;
                    var lng = firstPin.Longitude;
                }

                if (_this.filter.nearMe) {
                    lat = _this.currentLocation.lat;
                    lng = _this.currentLocation.lng;

                }

                const mapOptions = {
                    center: { lat: lat, lng: lng },
                    zoom: 10,
                };

                this.map = new google.maps.Map(document.getElementById('map'), mapOptions);
                this.pins.forEach(pin => {
                    this.addPin(pin);
                });
                if (_this.filter.nearMe) {
                    this.addPin({
                        Latitude: lat,
                        Longitude: lng,
                        Title: 'თქვენი მდებარე პოზიცია',
                        Icon: '',
                    });
                }
            },

            filterPinsByKeyword() {
                var _this = this;
                _this.pins = window.pins;


                var newUrl = updateSingleValueQueryParam('keyword', _this.filter.keyword);
                history.replaceState({}, null, newUrl);


                _this.filterPins();
            },

            containsType(type) {
                var _this = this;
                return _this.filter.selectedTypes.find(function (selectedType) {
                    return selectedType.Id == type.Id;
                });
            },

            filterBy24() {
                var _this = this;
                _this.filter.filterBy24 = !_this.filter.filterBy24;
                if (_this.filter.filterBy24) {
                    var newUrl = updateSingleValueQueryParam('open', 1);
                    history.replaceState({}, null, newUrl);
                } else {
                    var newUrl = updateSingleValueQueryParam('open', 0);
                    history.replaceState({}, null, newUrl);
                }
                _this.filterPins();
            },

            filterPins() {
                var _this = this;
                _this.pins = window.pins;

                if (_this.filter.selectedLocation.Id != undefined && _this.filter.selectedLocation.Id != null && _this.filter.selectedLocation.Id != 0) {
                    _this.pins = _this.pins.filter(function (pin) {
                        return pin.LocationId == _this.filter.selectedLocation.Id;
                    });
                }

                if (_this.filter.selectedTypes != null && _this.filter.selectedTypes.length > 0) {
                    _this.pins = _this.pins.filter(function (pin) {
                        return _this.filter.selectedTypes.find(function (selectedType) {
                            return selectedType.Id == pin.TypeId;
                        });
                    });
                }

                if (_this.filter.filterBy24) {
                    _this.pins = _this.pins.filter(function (pin) {
                        return pin.Open24Hours == true;
                    });
                }

                if (_this.filter.keyword != '') {
                    _this.pins = _this.pins.filter(function (pin) {
                        return pin.Title?.toLowerCase()?.includes(_this.filter.keyword.toLowerCase()) || pin.Address?.toLowerCase()?.includes(_this.filter.keyword.toLowerCase());
                    });
                }

                _this.initMap();
            },

            filterPinsByType(type) {
                var _this = this;
                if (_this.containsType(type)) {
                    _this.filter.selectedTypes = _this.filter.selectedTypes.filter(function (selectedType) {
                        return selectedType.Id != type.Id;
                    });
                    var typeIds = _this.filter.selectedTypes.map(function (type) {
                        return type.Id;
                    });
                    var newUrl = updateSingleValueQueryParam('type', typeIds);
                    history.replaceState({}, null, newUrl);
                    _this.filterPins();
                } else {
                    _this.filter.selectedTypes.push(type);
                    var typeIds = _this.filter.selectedTypes.map(function (type) {
                        return type.Id;
                    });
                    var newUrl = updateSingleValueQueryParam('type', typeIds);
                    history.replaceState({}, null, newUrl);
                    _this.filterPins();
                }

                _this.filterPins();
            },

            addPin(pin) {
                var _this = this;
                const marker = new google.maps.Marker({
                    position: { lat: pin.Latitude, lng: pin.Longitude },
                    map: this.map,
                    icon: pin.Icon,
                    title: pin.Title,
                });

                var infoWindowContent = `
                                             <div class="infowindow">
                                                 <h4 class="branches-item__title">`+ pin.Title + `</h4>
                                                 <p class="branches-item__address">`+ pin.Address + `</p>
                                                 <a href="`+ _this.getDirectionUrl(pin) + `" class="button button--link button--link-primary">
                                                     <svg class="button__icon button__icon--direction">
                                                         <use xlink:href="~/m/i/icons.svg#symbol-direction"></use>
                                                     </svg>
                                                     <span class="button__text">მიმართულების ჩვენება</span>
                                                 </a>
                                                 <div class="branches-item__options">
                                                     <div class="branches-item__options-item">
                                                         <span class="branches-item__options-label">სამუშაო საათები</span>
                                                         <span class="branches-item__options-value">`+ pin.WorkingHours + `</span>
                                                     </div>
                                                     <div class="branches-item__options-item">
                                                         <span class="branches-item__options-label">საკონტაქტო ინფორმაცია</span>
                                                         <span class="branches-item__options-value">`+ pin.ContactInfo + `</span>
                                                     </div>
                                                 </div>
                                             </div>`;


                var infoWindow = new google.maps.InfoWindow({
                    content: infoWindowContent
                });
                marker.addListener('click', function () {
                    infoWindow.open(map, marker);
                });

                return marker;
            },

            showDirection(item) {
                var _this = this;
                window.open(_this.getDirectionUrl(item));
            },

            getDirectionUrl(item) {
                return 'https://www.google.com/maps/dir/?api=1&destination=' + item.Latitude + ',' + item.Longitude;
            },

            getLocation() {
                var _this = this;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            _this.currentLocation.lat = position.coords.latitude;
                            _this.currentLocation.lng = position.coords.longitude;
                            _this.filter.nearMe = true;
                            //var newUrl = updateSingleValueQueryParam('near', _this.filter.nearMe == true ? 1 : 0);
                            //history.replaceState({}, null, newUrl);

                            _this.filterPins();

                            _this.orderedPins();
                        },
                        function (error) {
                            switch (error.code) {
                                case error.PERMISSION_DENIED:
                                    console.log("User denied the request for Geolocation.");
                                    break;
                                case error.POSITION_UNAVAILABLE:
                                    console.log("Location information is unavailable.");
                                    break;
                                case error.TIMEOUT:
                                    console.log("The request to get user location timed out.");
                                    break;
                                case error.UNKNOWN_ERROR:
                                    console.log("An unknown error occurred.");
                                    break;
                            }
                        });
                } else {
                    alert("Geolocation is not supported by this browser.");
                }
            },

            orderedPins() {
                var _this = this;
                if (_this.filter.nearMe == true) {
                    var orderedPins = _this.pins.map(function (pin) {
                        var distance = _this.calculateDistance(pin.Latitude, pin.Longitude);
                        pin.Distance = distance.toFixed(2);
                        return pin;
                    }).sort(function (a, b) {
                        return a.Distance - b.Distance;
                    });

                    _this.pins = orderedPins;
                }
            },

            calculateDistance(lat2, lon2) {
                var _this = this;
                function deg2rad(deg) {
                    return deg * (Math.PI / 180);
                }

                var lat1 = this.currentLocation.lat;
                var lon1 = this.currentLocation.lng;

                var R = 6371; // Radius of the earth in km
                var dLat = deg2rad(lat2 - lat1);  // deg2rad below
                var dLon = deg2rad(lon2 - lon1);
                var a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2)
                    ;
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c; // Distance in km
                return d;
            }
        },
        mounted() {
            var _this = this;
            _this.locations = window.pinLocations;
            _this.types = window.pinTypes;
            _this.pins = window.pins;

            var urlParams = new URLSearchParams(window.location.search)

            var locationId = urlParams.get('location');
            var near = urlParams.get('near');

            var typeIds = urlParams.get('type');
            var open = urlParams.get('open');
            var keyword = urlParams.get('keyword');

            if (open != null && open == 1) {
                _this.filter.filterBy24 = open == 1;
            }

            if (typeIds != null) {
                var typeIdsArray = typeIds.split(',');
                _this.filter.selectedTypes = _this.types.filter(function (type) {
                    return typeIdsArray.includes(type.Id.toString());
                });
            }

            if (locationId != null) {
                _this.filter.selectedLocation = _this.locations.find(function (location) {
                    return location.Id == locationId;
                });
            }

            if (keyword != null && keyword.length > 0) {
                _this.filter.keyword = keyword;
            }

            if (_this.filter.nearMe == true) {
                _this.getLocation();
            }
            _this.filterPins();
            _this.initMap();
        }
    ,
template: `
    <div>
        <div class="blocks-wrapper">
            <section class="hero hero--vertical">
                <div class="container">
                    <div class="hero__content">
                        <div class="hero__info">
                            <h1>{{getPageTitle()}}</h1>
                        </div>
                        <div class="hero-search">
                            <div class="hero-search__field-wrap">
                                <input type="text" class="hero-search__field" :placeholder="$phrase('branches_keywordplaceholder')" :aria-label="$phrase('branches_keywordplaceholder')" v-model="filter.keyword" @input="filterPinsByKeyword()" />
                                <a href="" class="hero-search__search-action">
                                    <svg class="hero-search__search-action-icon">
                                        <use xlink:href="~/m/i/icons.svg#symbol-magnifier"></use>
                                    </svg>
                                </a>
                                <a href="" class="button button--link button--link-primary hero-search__nearme" @click.prevent="getLocation()">
                                    <svg class="button__icon button__icon--gps">
                                        <use xlink:href="~/m/i/icons.svg#symbol-gps"></use>
                                    </svg>
                                    <span class="button__text">{{$phrase('branches_newartome')}}</span>
                                </a>
                            </div>
                            <div class="hero-search__actions">
                                <div class="hero-search__filters">
                                    <div class="hero-search__filter-dropdown">
                                        <a href="" class="hero-search__filter-dropdown-trigger js-trigger">
                                            <span class="hero-search__filter-dropdown-trigger-text" v-show="filter.selectedLocation == ''">{{$phrase('branches_regions')}}</span>
                                            <span class="hero-search__filter-dropdown-trigger-text" v-show="filter.selectedLocation != '' && filter.selectedLocation.Title != null">{{filter.selectedLocation.Title}}</span>
                                            <svg class="hero-search__filter-dropdown-trigger-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                            </svg>
                                        </a>
                                        <div class="hero-search__filter-dropdown-results js-results">
                                            <div class="hero-search__filter-dropdown-results-content">
                                                <a href="" class="hero-search__filter-dropdown-results-item" v-for="location in locations" @click.prevent="selectLocation(location)">
                                                    {{location.Title}}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hero-search__filters-list">

                                        <a href="" class="hero-search__filter-category js-select-type" @click.prevent="filterPinsByType(type)" v-for="type in types" :class="{'active' : containsType(type)}">
                                            <span class="hero-search__filter-category-text">{{type.Title}}</span>
                                        </a>

                                        <a href="" class="hero-search__filter-category" @click.prevent="filterBy24()" :class="{'active' : filter.filterBy24 == true}">
                                            <span class="hero-search__filter-category-text">{{$phrase('branches_24hours')}}</span>
                                        </a>

                                    </div>
                                </div>
                                <div class="hero-search__switch-toggle">
                                    <span class="hero-search__switch-toggle-label">{{$phrase('branches_map')}}</span>
                                    <label for="toggle" class="hero-search__switch-toggle-item">
                                        <input type="checkbox" id="toggle" class="js-map-toggle" v-model="filter.showMap" />
                                        <span class="hero-search__switch-toggle-slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="blocks-wrappper--sidebar" v-show="!filter.showMap">
            <div class="page-flow">
                <div class="page-main page-main--short">
                    <div class="page-main__content">
                        <section class="section">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="section__content">
                                            <div class="section__body">
                                                <div class="branches">

                                                    <div v-for="pin in pins"
                                                         class="branches-item">
                                                        <div class="branches-item__media">
                                                            <img v-bind:src="pin.PhotoUrl" alt="">
                                                        </div>
                                                        <div class="branches-item__text">
                                                            <h4 class="branches-item__title" v-if="pin.Distance != null">{{pin.Title}} - {{ pin.Distance }} კმ</h4>
                                                            <h4 class="branches-item__title" v-if="pin.Distance == null">{{pin.Title}}</h4>
                                                            <p class="branches-item__address">{{pin.Address}}</p>
                                                            <a href="" class="button button--link button--link-primary"
                                                               @click.prevent="showDirection(pin)">
                                                                <svg class="button__icon button__icon--direction">
                                                                    <use xlink:href="~/m/i/icons.svg#symbol-direction"></use>
                                                                </svg>
                                                                <span class="button__text">{{$phrase('branches_showdirection')}}</span>
                                                            </a>
                                                            <div class="branches-item__options">
                                                                <div class="branches-item__options-item">
                                                                    <span class="branches-item__options-label">{{$phrase('branches_workinghours')}}</span>
                                                                    <span class="branches-item__options-value">{{pin.WorkingHours}}</span>
                                                                </div>
                                                                <div class="branches-item__options-item">
                                                                    <span class="branches-item__options-label">{{$phrase('branches_contactinfo')}}</span>
                                                                    <span class="branches-item__options-value">{{pin.ContactInfo}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a href="" class="branches-item__action"
                                                           @click.prevent="showDirection(pin)">
                                                            <img class="branches-item__action-bg" src="~/m/u/branches/map-thumb.jpg" alt="">
                                                            <img class="branches-item__action-pin" v-bind:src="pin.Icon" alt="">
                                                        </a>
                                                    </div>

                                                    <a href="" class="branches-switch" @click.prevent="toggleMap(true)">
                                                        <svg class="branches-switch__icon">
                                                            <use xlink:href="~/m/i/icons.svg#symbol-pin-rich"></use>
                                                        </svg>
                                                        <span class="branches-switch__text">{{$phrase('branches_map')}}</span>
                                                    </a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>

        <div class="blocks-wrapper js-branch-map" v-show="filter.showMap">
            <div class="branches-map" id="branches-map">
                <div id="map"></div>
                <a href="" class="branches-switch" @click.prevent="toggleMap(false)">
                    <svg class="branches-switch__icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-pin-rich"></use>
                    </svg>
                    <span class="branches-switch__text">{{$phrase('branches_list')}}</span>
                </a>
            </div>
        </div>

    </div>
`
});
Vue.component('developers-list', {
        props: {},
        data: function () {
            return {
                offers: [],
                cities: [],
                filteredOffers: [],
                selectedItems: [],
                visibleOffers: [],
                specialOfferChecked: false,
                keyword: '',
                orderedByDesc: true,
                pagination: {
                    currentPage: 1,
                    itemsPerPage: 12,
                    showPager: false
                }
            }
        },

        methods: {
            closeFilter() {
                var filters = document.querySelector('.developers-filters');
                document.body.classList.remove('noscroll');
                filters.style.transform = "translateY(100%)";
            },
            changePage(page) {
                var _this = this;
                if (page !== _this.pagination.currentPage && page > 0 && page <= _this.totalPages) {
                    _this.pagination.currentPage = page;
                    _this.updateVisibleItems();
                }
            },
            updateVisibleItems() {
                const start = (this.pagination.currentPage - 1) * this.pagination.itemsPerPage;
                const end = start + this.pagination.itemsPerPage;
                const visibleItems = this.filteredOffers.slice(start, end);
                this.visibleOffers = visibleItems;
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            },
            orderOffers() {
                var _this = this;

                _this.orderedByDesc = !_this.orderedByDesc;
                
                if (_this.orderedByDesc) {
                    _this.visibleOffers = _this.visibleOffers.sort((a, b) => new Date(a.createDt) - new Date(b.createDt));
                } else {
                    _this.visibleOffers = _this.visibleOffers.sort((a, b) => new Date(b.createDt) - new Date(a.createDt));
                }

            },
            removeSelectedItem(item) {
                var _this = this;

                var checkedDistricts = _this.cities.map(city => city.districts.filter(district => district.checked).map(district => district)).flat() || [];
                var checkedCities = _this.cities.filter(city => city.checked).map(city => city) || [];

                if (checkedCities.length > 0) {
                    checkedCities.forEach(city => {
                        if (city.id === item.id && city.title === item.title) {
                            city.checked = false;
                        }
                    });
                }

                if (checkedDistricts.length > 0) {
                    checkedDistricts.forEach(district => {
                        if (district.id === item.id && district.title === item.title) {
                            district.checked = false;
                        }
                    });
                }

                this.filterOffers();
            },
            getSpecialOffersCount() {
                return this.filteredOffers.filter(offer => offer.isSpecialOffer).length;
            },
            getAllOffersCount() {
                var allCitiesOffersCount = this.cities.map(city => this.getCityOffersCount(city)).reduce((a, b) => a + b, 0);
                return allCitiesOffersCount;
            },
            getCityOffersCount(city) {
                var filteredOffers = this.offers.filter(offer => offer.distict.city.id === city.id);

                if (this.specialOfferChecked) {
                    filteredOffers = filteredOffers.filter(offer => offer.isSpecialOffer);
                }

                if (this.keyword.length) {
                    filteredOffers = filteredOffers.filter(offer => offer.title.toLowerCase().includes(this.keyword.toLowerCase()));
                }

                return filteredOffers.length;
            },
            getDistrictOffersCount(district) {
                var filteredOffers = this.offers.filter(offer => offer.distict.id === district.id);

                if (this.specialOfferChecked) {
                    filteredOffers = filteredOffers.filter(offer => offer.isSpecialOffer);
                }

                if (this.keyword.length) {
                    filteredOffers = filteredOffers.filter(offer => offer.title.toLowerCase().includes(this.keyword.toLowerCase()));
                }

                return filteredOffers.length;
            },
            selectSpecialOffer(checked) {
                this.specialOfferChecked = checked;
                //this.updateCityOffersQuanaities();
                this.filterOffers();
            },
            showDistrictsFilter() {
                return this.cities.some(city => city.checked);
            },
            filterOffers() {
                var _this = this;
                var offers = _this.offers;
                _this.filteredOffers = offers;

                var checkedCities = _this.cities.filter(city => city.checked).map(city => city) || [];

                var unChechedCities = _this.cities.filter(city => !city.checked).map(city => city) || [];

                unChechedCities.forEach(city => {
                    _this.diselectDistricts(city);
                });

                var checkedDistricts = _this.cities.map(city => city.districts.filter(district => district.checked).map(district => district)).flat() || [];

                if (checkedDistricts.length > 0) {
                    _this.filteredOffers = offers.filter(function (offer) {
                        return checkedDistricts.some(district => district.id === offer.distict.id);
                    });
                } else if (checkedCities.length > 0) {
                    _this.filteredOffers = offers.filter(function (offer) {
                        return checkedCities.some(city => city.id === offer.distict.city.id);
                    });
                }

                if (_this.specialOfferChecked) {
                    _this.filteredOffers = _this.filteredOffers.filter(offer => offer.isSpecialOffer);
                }

                if (_this.keyword.length) {
                    _this.filteredOffers = _this.filteredOffers.filter(offer => offer.title.toLowerCase().includes(_this.keyword.toLowerCase()) || offer.address.toLowerCase().includes(_this.keyword.toLowerCase()));
                }
                _this.orderOffers();
                _this.getSelectedItems();
                _this.pagination.currentPage = 1;
                _this.pagination.showPager = _this.filteredOffers.length > _this.pagination.itemsPerPage;
            },
            diselectDistricts(city) {
                city.districts.forEach(district => district.checked = false);
            },
            getSelectedItems() {
                var _this = this;

                _this.selectedItems = [];

                var checkedDistricts = _this.cities.map(city => city.districts.filter(district => district.checked).map(district => district)).flat() || [];
                var checkedCities = _this.cities.filter(city => city.checked).map(city => city) || [];

                if (checkedCities.length > 0) {
                    _this.selectedItems = _this.selectedItems.concat(checkedCities);
                }

                if (checkedDistricts.length > 0) {
                    _this.selectedItems = _this.selectedItems.concat(checkedDistricts);
                }

            },
            loadOffers() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'DevelopersApi/GetDevelopersList';

                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        _this.offers = response.data.data;
                        _this.filteredOffers = _this.offers;

                        const cityDistrictMap = _this.offers.reduce((acc, offer) => {
                            const { city, title, orderIndex } = offer.distict;
                            if (!acc[city.id]) {
                                acc[city.id] = {
                                    id: city.id,
                                    title: city.title,
                                    orderIndex: city.orderIndex,
                                    districts: []
                                };
                            }
                            if (!acc[city.id].districts.find(district => district.id === offer.distict.id)) {
                                acc[city.id].districts.push({ id: offer.distict.id, title, orderIndex });
                                acc[city.id].districts.sort((a, b) => b.orderIndex - a.orderIndex); // Reverse the order
                            }
                            return acc;
                        }, {});

                        const citiesWithDistricts = Object.values(cityDistrictMap);

                        citiesWithDistricts.sort((a, b) => b.orderIndex - a.orderIndex); // Reverse the order

                        _this.cities = citiesWithDistricts;
                        _this.filterOffers();
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            },
        },
        computed: {
            totalPages() {
                return Math.ceil(this.filteredOffers.length / this.pagination.itemsPerPage);
            },
            startPage() {
                if (this.pagination.currentPage <= 3) {
                    return 2;
                } else if (this.pagination.currentPage >= this.totalPages - 2) {
                    return this.totalPages - 3;
                } else {
                    return this.pagination.currentPage - 1;
                }
            },
            endPage() {
                if (this.pagination.currentPage <= 3) {
                    return Math.min(4, this.totalPages - 1);
                } else if (this.pagination.currentPage >= this.totalPages - 2) {
                    return this.totalPages - 1;
                } else {
                    return this.pagination.currentPage + 1;
                }
            },
            pages() {
                let pages = [];
                for (let i = this.startPage; i <= this.endPage; i++) {
                    pages.push(i);
                }
                return pages;
            },
        },
        mounted() {
            this.loadOffers();
        },
        watch: {
            currentPage: {
                immediate: true,
                handler() {
                    this.updateVisibleItems();
                },
            },
            filteredOffers: {
                immediate: true,
                handler() {
                    this.updateVisibleItems();
                },
            },
        }
    ,
template: `
    <div class="page-flow page-flow--short-sidebar">
        <div class="page-sidebar page-sidebar--nonsticky">
            <div class="developers-filters">
                <div class="developers-filters__content">
                    <a href="" class="developers-filters__close" @click.prevent="closeFilter()">
                        <svg class="developers-filters__close-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </a>
                    <div class="developers-filters__item">
                        <h4 class="developers-filters__item-title">{{$phrase('developerslist_location')}}</h4>
                        <div class="developers-filters__item-list">

                            <div class="radiocheckbox radiocheckbox--checkbox radiocheckbox--w-bg" v-for="city in cities">
                                <input type="checkbox" name="city" :id="'city-' + city.id" class="radiocheckbox__input" :aria-label="city.title"
                                       v-model="city.checked"
                                       @change="filterOffers()">
                                <label :for="'city-' + city.id" class="radiocheckbox__label">
                                    <div class="radiocheckbox__icon-wrap">
                                        <svg class="radiocheckbox__icon">
                                            <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                                        </svg>
                                    </div>
                                    <span class="radiocheckbox__text">{{city.title}}</span>
                                    <span class="radiocheckbox__count">{{getCityOffersCount(city)}}</span>
                                </label>
                            </div>

                        </div>
                    </div>
                    <div class="developers-filters__item" v-if="showDistrictsFilter()">
                        <h4 class="developers-filters__item-title">{{$phrase('developerslist_district')}}</h4>
                        <div class="developers-filters__item-list">

                            <div v-for="city in cities">
                                <div class="radiocheckbox radiocheckbox--checkbox radiocheckbox--w-bg" v-if="city.checked" v-for="district in city.districts">
                                    <input type="checkbox" name="district" :id="'district-' + district.id" class="radiocheckbox__input" :aria-label="district.title"
                                           v-model="district.checked"
                                           @change="filterOffers()">
                                    <label :for="'district-' + district.id" class="radiocheckbox__label">
                                        <div class="radiocheckbox__icon-wrap">
                                            <svg class="radiocheckbox__icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                                            </svg>
                                        </div>
                                        <span class="radiocheckbox__text">{{district.title}}</span>
                                        <span class="radiocheckbox__count">{{getDistrictOffersCount(district)}}</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="developers-filters__item">
                        <h4 class="developers-filters__item-title">{{$phrase('developerslist_type')}}</h4>
                        <div class="developers-filters__item-list">
                            <div class="radiocheckbox radiocheckbox--radio radiocheckbox--w-bg">
                                <input type="radio" name="cr" id="cr1" class="radiocheckbox__input" :aria-label="$phrase('developerslist_all')" @change="selectSpecialOffer(true)">
                                <label for="cr1" class="radiocheckbox__label">
                                    <div class="radiocheckbox__icon-wrap">
                                        <span class="radiocheckbox__icon"></span>
                                    </div>
                                    <span class="radiocheckbox__text">{{$phrase('developerslist_offer')}}</span>
                                    <span class="radiocheckbox__count">{{getSpecialOffersCount()}}</span>
                                </label>
                            </div>
                            <div class="radiocheckbox radiocheckbox--radio radiocheckbox--w-bg">
                                <input type="radio" name="cr" id="cr2" class="radiocheckbox__input" :aria-label="$phrase('developerslist_offer')" @change="selectSpecialOffer(false)">
                                <label for="cr2" class="radiocheckbox__label">
                                    <div class="radiocheckbox__icon-wrap">
                                        <span class="radiocheckbox__icon"></span>
                                    </div>
                                    <span class="radiocheckbox__text">{{$phrase('developerslist_all')}}</span>
                                    <span class="radiocheckbox__count">{{getAllOffersCount()}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="developers-filters__action">
                        <a href="" class="button button--primary button--default" @click.prevent="closeFilter()">
                            <span class="button__text">{{$phrase('developerslist_search')}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <!--<div class="banners">
                <div class="banners__item">
                    <div class="banners__media">
                        <img src="~/m/u/banners/1.jpg" alt="">
                    </div>
                    <div class="banners__text">
                        <h4>გახდი ჩვენი პარტნიორი</h4>
                        <a href="" class="banners__button">
                            <span class="banners__button-text">გაიგე მეტი</span>
                        </a>
                    </div>
                </div>
            </div>-->
        </div>
        <div class="page-main">
            <div class="page-main__content">
                <section class="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section__content">
                                    <div class="section__body">
                                        <div class="developers-search-actions">
                                            <div class="developers-search-actions__search">
                                                <input type="text" class="developers-search-actions__search-field" :placeholder="$phrase('developerslist_searchplaceholder')" v-model="keyword" @input="filterOffers()" />
                                                <a href="" class="developers-search-actions__search-action">
                                                    <svg class="developers-search-actions__search-icon">
                                                        <use xlink:href="~/m/i/icons.svg#symbol-magnifier"></use>
                                                    </svg>
                                                </a>
                                                <a href="" class="developers-search-actions__filter">
                                                    <svg class="developers-search-actions__filter-icon">
                                                        <use xlink:href="~/m/i/icons.svg#symbol-filter"></use>
                                                    </svg>
                                                </a>
                                            </div>
                                            <div class="developers-search-actions__sort">
                                                <span class="developers-search-actions__sort-label">{{$phrase('developerslist_sort')}}</span>
                                                <a href="" class="button button--link button--link-primary button-sort" @click.prevent="orderOffers()"
                                                   :class="{'open': orderedByDesc}">
                                                    <span class="button__text">{{$phrase('developerslist_sortbydate')}}</span>
                                                    <svg class="button__icon button__icon--chevron-down">
                                                        <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                                    </svg>
                                                </a>
                                            </div>
                                            <div class="developers-search-tags">
                                                <div class="developers-search-tags__item" v-for="item in selectedItems">
                                                    <span class="developers-search-tags__item-text">{{item.title}}</span>
                                                    <a href="" class="developers-search-tags__item-action"
                                                       @click.prevent="removeSelectedItem(item)">
                                                        <svg class="developers-search-tags__item-icon">
                                                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                                        </svg>
                                                    </a>
                                                </div>

                                                <div class="developers-search-tags__item" v-if="specialOfferChecked">
                                                    <span class="developers-search-tags__item-text">{{$phrase('developerslist_offer')}}</span>
                                                    <a href="" class="developers-search-tags__item-action"
                                                       @click.prevent="specialOfferChecked = false">
                                                        <svg class="developers-search-tags__item-icon">
                                                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="developers-list">

                                            <div class="developer-offer-item" v-for="offer in visibleOffers">
                                                <div class="developer-offer-item__media">
                                                    <img v-bind:src="offer.imageUrl" :alt="offer.title">
                                                    <span class="product-label product-label--primary" v-if="offer.isSpecialOffer">{{$phrase('developerslist_specialprice')}}</span>
                                                </div>
                                                <div class="developer-offer-item__text">
                                                    <div class="developer-offer-item__head">
                                                        <h4>{{offer.title}}</h4>
                                                    </div>
                                                    <p>{{offer.address}}</p>
                                                    <p class="developer-offer-item__price">{{$phrase('developerslist_sqm')}}<span>{{offer.sqMeterPrice}}</span></p>
                                                    <div class="developer-offer-item__actions">
                                                        <a :href="offer.url" class="button button--primary button--small">
                                                            <span class="button__text">{{$phrase('developerslist_seedetails')}}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="page-actions" v-if="pagination.showPager">
                                         
                                            <div class="pager">
                                                <a href="" class="pager__item pager__item--prev"
                                                   @click.prevent="changePage(pagination.currentPage - 1)" :disabled="pagination.currentPage === 1">
                                                    <svg class="pager__item-icon">
                                                        <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                                    </svg>
                                                </a>
                                                <a href="" class="pager__item" @click.prevent="changePage(1)" :class="{ active: pagination.currentPage === 1 }">
                                                    <span class="pager__item-text">1</span>
                                                </a>
                                                <a href="" class="pager__item pager__item--empty" v-if="startPage > 2">
                                                    <span class="pager__item-text">...</span>
                                                </a>
                                                <a href="" class="pager__item"
                                                   v-for="page in pages"
                                                   :key="page"
                                                   @click.prevent="changePage(page)"
                                                   :class="{ active: pagination.currentPage === page }">
                                                    <span class="pager__item-text">{{ page }}</span>
                                                </a>
                                                <a href="" class="pager__item pager__item--empty" v-if="endPage < totalPages - 1">
                                                    <span class="pager__item-text">...</span>
                                                </a>
                                                <a href="" class="pager__item" @click.prevent="changePage(totalPages)"
                                                   :class="{ active: pagination.currentPage === totalPages }">
                                                    <span class="pager__item-text">{{ totalPages }}</span>
                                                </a>
                                                <a href="" class="pager__item pager__item--next" @click.prevent="changePage(pagination.currentPage + 1)" :disabled="pagination.currentPage === totalPages">
                                                    <svg class="pager__item-icon">
                                                        <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                                    </svg>
                                                </a>
                                            </div>
                                            <!--<div class="items-on-page">
                                                <span class="items-on-page__label">სიახლეები ერთ გვერდზე</span>
                                                <div class="items-on-page__dropdown">
                                                    <a href="" class="items-on-page__dropdown-trigger js-trigger">
                                                        <span class="items-on-page__dropdown-trigger-text">10</span>
                                                        <svg class="items-on-page__dropdown-trigger-icon">
                                                            <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                                        </svg>
                                                    </a>
                                                    <div class="items-on-page__dropdown-results js-results">
                                                        <div class="items-on-page__dropdown-results-content">
                                                            <a href="" class="items-on-page__dropdown-results-item">5</a>
                                                            <a href="" class="items-on-page__dropdown-results-item">15</a>
                                                            <a href="" class="items-on-page__dropdown-results-item">20</a>
                                                            <a href="" class="items-on-page__dropdown-results-item">25</a>
                                                            <a href="" class="items-on-page__dropdown-results-item">30</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
`
});
Vue.component('header-search', {
        props: {
            formSubmitAction: {
                type: String,
                required: true
            },
            recommendedServices: {
                type: Array,
                required: true
            }
        },
        data: function () {
            return {
                suggestionDebouceIntervalMs: 1000,
                query: null,
                isOpen: false,
                suggestionTimeout: null,
                loading: false,
                suggestions: [],
                queryHistory: []
            }
        },

        methods: {
            getRootClasses() {
                return {
                    'open': this.isOpen
                }
            },

            onSubmit(event) {
                const canSubmit = this._canSubmit()
                if (!canSubmit) {
                    event.preventDefault();
                }

                StorageService.shared.addSearchQuery(this.sanitizedQuery)
            },

            onCloseRequest() {
                this.isOpen = false
                document.body.classList.remove('search-open')
                UiService.shared.dispatchHeaderSearchCloseRequestedEvent()
            },

            onInput() {
                clearTimeout(this.suggestionTimeout)

                setTimeout(() => {
                    this._loadSuggestions()
                }, this.suggestionDebouceIntervalMs)

                if (!this.sanitizedQuery) {
                    this.suggestions = []
                }
            },

            showRecommendations() {
                if (this.queryHistory.length) {
                    return false
                }

                if (!this.recommendedServices) {
                    return false
                }

                if (!this.recommendedServices.length) {
                    return false
                }

                const show = !this.showSuggestions()
                return show
            },

            showSuggestions() {
                const show = this.suggestions && this.suggestions.length
                return show
            },

            showQueryHistory() {
                if (!this.queryHistory.length) {
                    return false
                }

                const show = !this.showSuggestions()
                return show
            },

            showViewAllButton() {
                const canSubmit = this._canSubmit()
                return canSubmit
            },

            getQueryHistoryTargetUrl(entry) {
                var url = window._data.homeUrl + 'search?query=' + entry
                return url
            },

            onHistoryEntryClicked(entry) {
                //this.query = entry
                //this._loadSuggestions()
            },

            _canSubmit() {
                if (!this.sanitizedQuery) {
                    return false
                }

                if (!this.sanitizedQuery.length) {
                    return false
                }

                if (this.sanitizedQuery.length < 4) {
                    return false
                }

                return true
            },

            _loadQueryHistory() {
                this.queryHistory = StorageService.shared.getSearchQueries().reverse()
            },

            async _loadSuggestions() {
                if (this.loading) {
                    return
                }

                if (!this._canSubmit()) {
                    return
                }

                this.loading = true
                const query = this.sanitizedQuery
                try {
                    var endpointUrl = window._data.apiBaseUrl + 'SearchApi/GetSuggestions'
                    var response = await axios.post(endpointUrl, {
                        langAbbr: window._data.languageAbbr,
                        query: query
                    })

                    if (response
                        && response.data
                        && response.data.data
                        && response.data.data.suggestions) {
                        this.suggestions = response.data.data.suggestions
                    }

                    this._loadQueryHistory()
                }
                catch (err) {
                    this.suggestions = []
                }
                finally {
                    this.loading = false
                }
            }
        },

        computed: {
            sanitizedQuery() {
                if (!this.query) {
                    return ""
                }

                const trimmedQuery = this.query.trim()
                if (!trimmedQuery) {
                    return ""
                }

                return trimmedQuery
            }
        },

        mounted() {
            document.addEventListener('headersearchopenrequested', (event) => {
                document.body.classList.add('search-open')

                setTimeout(() => {
                    this.isOpen = true
                    this.$refs.query.focus()
                }, 150)
            })

            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }

                if (event.target.classList) {
                    for (let className of event.target.classList) {
                        if (className.includes('search')) {
                            return
                        }
                    }
                }

                this.onCloseRequest()
            })

            this._loadQueryHistory()
        }
    ,
template: `
    <div class="header-search" :class="getRootClasses()">
        <div class="header-search__content">
            <div class="container">
                <form :action="formSubmitAction" method="get" @submit="onSubmit" autocomplete="off" class="header-search__actions">
                    <input ref="query" v-model="query" @input="onInput" type="text" class="header-search__field" name="query" />
                    <button type="submit" class="header-search__action">
                        <svg class="header-search__action-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-magnifier"></use>
                        </svg>
                    </button>
                    <div v-show="showViewAllButton()" class="header-search__button-wrap">
                        <button class="header-search__viewall button button--link button--link-primary">
                            <span class="button__text">{{ $phrase('search_header-viewall') }}</span>
                            <svg class="button__icon button__icon--chevron-right">
                                <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                            </svg>
                        </button>
                        <span class="header-search__divider"></span>
                    </div>
                    <a @click.prevent="onCloseRequest()" href="" class="header-search__close">
                        <svg class="header-search__close-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </a>
                </form>

                <div v-if="showRecommendations()" class="header-search__results">
                    <h4 class="header-search__results-title">{{ $phrase('search_header-recommended-services') }}</h4>

                    <div class="header-search__results-list">

                        <a :href="service.Url" class="header-search__results-item"
                           v-for="service in recommendedServices">
                            <span class="header-search__results-item-text">{{ service.Title }}</span>
                            <svg class="header-search__results-item-icon">
                                <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                            </svg>
                        </a>

                    </div>
                </div>

                <div v-if="showQueryHistory()" class="header-search__results">
                    <h4 class="header-search__results-title">{{ $phrase('search_header-results-title') }}</h4>

                    <div class="header-search__results-list">

                        <a class="header-search__results-item"
                           :href="getQueryHistoryTargetUrl(entry)"
                           @click="onHistoryEntryClicked(entry)"
                           v-for="entry in queryHistory">
                            <span class="header-search__results-item-text">{{ entry }}</span>
                            <svg class="header-search__results-item-icon">
                                <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                            </svg>
                        </a>

                    </div>
                </div>

                <div v-if="showSuggestions()" class="header-search__results">
                    <div class="header-search__results-list">
                        <a :href="service.url" class="header-search__results-item"
                           v-for="service in suggestions">
                            <span class="header-search__results-item-text">{{ service.title }}</span>
                            <svg class="header-search__results-item-icon">
                                <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                            </svg>
                        </a>

                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('consumer-loan-calculator', {
        props: {
            config: {
                type: Object,
                required: true
            },
            hideAmountSlider: {
                type: Boolean,
                required: false
            }
        },

        emits: [],

        data: function () {
            return {
                principal: null,
                minPrincipal: null,
                maxPrincipal: null,
                term: null,
                currency: '₾',
                currencies: [],
                minTerm: null,
                maxTerm: null,
                startTerm: null
            }
        },

        methods: {
            onMeasureUpdated(measureVal) {
                this.currency = measureVal
                this._initializeCurrencyConfiguration()
            },

            onShowSchedule() {
                const elem = this.$refs['secure-consumer-load-calculator-schedule']
                Fancybox.show([{ src: elem, type: 'inline' }])
            },

            formatNumberWithCurrency(value) {
                const formattedValue = TextFormattingService.formatCalculatorFloat(value)
                const formattedValueWithCurrency = `${formattedValue}${this.currency}`
                return formattedValueWithCurrency
            },

            formatNumber(value) {
                const formattedValue = TextFormattingService.formatCalculatorFloat(value)
                return formattedValue
            },

            calculateEffectivePercent() {
                const payments = [...this.schedule]
                const effectivePercent = LoanService.shared.calculateEffectivePercent(payments, this.principal)
                const formattedPercent = TextFormattingService.formatCalculatorFloat(effectivePercent)
                return formattedPercent
            },

            _initializeConfiguration() {
                this.currencies = [...new Set(this.config.ranges.map(rate => rate.currency))]

                this.principal = parseInt(this.config.initialAmount)
                this.minPrincipal = parseInt(this.config.minAmount)
                this.maxPrincipal = parseInt(this.config.maxAmount)

                this._initializeCurrencyConfiguration()
            },

            _initializeCurrencyConfiguration() {
                this.minTerm = this.config.ranges
                    .filter(rate => rate.currency === this.currency)
                    .reduce((min, rate) => rate.minTerm < min ? rate.minTerm : min, Infinity)

                this.maxTerm = Math.max(...this.config.ranges
                    .filter(rate => rate.currency === this.currency)
                    .map(rate => rate.maxTerm))
               
                const initialTerm = this.config.ranges.filter(rate => rate.currency === this.currency)[0].initialTerm
                this.startTerm = initialTerm >= this.minTerm && initialTerm <= this.maxTerm
                    ? initialTerm
                    : parseInt((this.minTerm + this.maxTerm) / 2)
            }
        },

        computed: {
            schedule() {
                const payments = LoanService.shared.calculateLoanPayments(this.principal, this.percent, this.term)
                return payments
            },

            monthlyPaymentAmount() {
                if (!this.schedule || !this.schedule.length) {
                    return ''
                }

                const amount = parseFloat(this.schedule[0].monthlyPayment)
                const formattedAmount = TextFormattingService.formatCalculatorFloat(amount)
                return formattedAmount
            },

            percent() {
                const entry = this.config.ranges
                    .find(rate =>
                        this.term >= rate.minTerm
                        && this.term <= rate.maxTerm
                        && rate.currency === this.currency
                    )

                if (!entry) {
                    return 0
                }

                return entry.percent || 0;
            }
        },

        mounted() {
            UiService.shared.dispatchComponentMountedEvent(this.$el, 'consumer-loan-calculator')
        },

        created() {
            this._initializeConfiguration()
        }
    ,
template: `

    <div class="calculator__content">
        <div class="calculator__item">
            <div class="js-col-controls">
                <calculator-slider v-model="principal" @update:measure="onMeasureUpdated" :title="$phrase('calculators_consumer-principal')" :min-value="minPrincipal" :start-value="principal" :max-value="maxPrincipal" measure="₾" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')" :dropdown-list="currencies" :hide-slider-controls="hideAmountSlider"></calculator-slider>

                <calculator-slider v-model="term" :title="$phrase('calculators_consumer-term')" :min-value="minTerm" :start-value="startTerm" :max-value="maxTerm" :measure="$phrase('calculators_month')" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')"></calculator-slider>
            </div>
        </div>

        <div class="calculator__item">
            <div class="calculator__results js-col-results">
                <div class="calculator__results-info">
                    <span class="calculator__results-label">{{ $phrase('calculators_consumer-result-monthlypayment') }}</span>
                    <h4 class="calculator__results-key">{{ monthlyPaymentAmount }}{{ currency }}</h4>
                </div>
                <div class="calculator__results-options">
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_consumer-result-annualpercent') }}</span>
                        <p class="calculator__results-options-value">{{ formatNumber(percent) }}%{{ $phrase('calculators_consumer-result-annualpercentsuffix') }}</p>
                    </div>
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_consumer-result-effectivepercent') }}</span>
                        <p class="calculator__results-options-value">{{ calculateEffectivePercent() }}%{{ $phrase('calculators_consumer-result-effectivepercentsuffix') }}</p>
                    </div>
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_consumer-result-term') }}</span>
                        <p class="calculator__results-options-value">{{ term }} {{ $phrase('calculators_month') }}</p>
                    </div>
                </div>
                <div class="calculator__results-actions">
                    <a :href="config.applyUrl" class="button button--primary button--default">
                        <span class="button__text">{{ $phrase('calculators_consumer-result-applyonline') }}</span>
                    </a>
                    <a href="javscript:void(0)" class="button button--primary-reverse button--default"
                       @click.prevent="onShowSchedule()">
                        <span class="button__text">{{ $phrase('calculators_consumer-result-viewschedule') }}</span>
                    </a>
                </div>
                <p class="calculator__results-warning" v-html="$phrase('calculators_resultsdisclaimer')"></p>
            </div>
        </div>
    </div>

    <div class="dialog-content" ref="secure-consumer-load-calculator-schedule" style="display: none;">
        <div class="dialog-content__head">
            <h3 class="dialog-content__title">{{$phrase('calculators_schedule-title') }}</h3>
        </div>
        <div class="dialog-content__body">
            <div class="page-text">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>
                                    <p>#</p>
                                </th>
                                <th>
                                    <p>{{$phrase('calculators_schedule-principal') }}</p>
                                </th>
                                <th>
                                    <p>{{$phrase('calculators_schedule-interest') }}</p>
                                </th>
                                <th>
                                    <p>{{$phrase('calculators_schedule-monthlypayment') }}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="payment in schedule">
                                <td>
                                    <p>{{ payment.paymentNumber }}</p>
                                </td>
                                <td>
                                    <p>{{ formatNumberWithCurrency(payment.principalAmount) }}</p>
                                </td>
                                <td>
                                    <p>{{ formatNumberWithCurrency(payment.interestAmount) }}</p>
                                </td>
                                <td>
                                    <p>{{ formatNumberWithCurrency(payment.monthlyPayment) }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


`
});
Vue.component('deposit-calculator', {
        props: {
            config: {
                type: Object,
                required: true
            },
            isAccumulative: {
                type: Boolean,
                default: false,
                required: true
            },
            isCertificate: {
                type: Boolean,
                default: false,
                required: true
            }
        },

        emits: [],

        data: function () {
            return {
                depositAmount: null,
                term: null,
                currency: '₾',
                currencies: [],
                minTerm: null,
                maxTerm: null,
                startTerm: null,
                enrollmentPeriod: null,
                enrollmentPeriodsTitle: null,
                enrollmentPeriodsList: [],
                monthlyTrancheAmount: null
            }
        },

        methods: {
            showMonthlyTrancheInput() {
                return this.isAccumulative
            },

            onMeasureUpdated(measureVal) {
                this.currency = measureVal

                const initialTerm = this.config.ranges.filter(rate => rate.currency === this.currency)[0].initialTerm
                if (initialTerm >= this.minTerm && initialTerm <= this.maxTerm) {
                    this.startTerm = initialTerm
                }
            },

            formatNumberWithCurrency(value) {
                const formattedValue = TextFormattingService.formatCalculatorFloat(value)
                const formattedValueWithCurrency = `${formattedValue}${this.currency}`
                return formattedValueWithCurrency
            },

            formatNumber(value) {
                const formattedValue = TextFormattingService.formatCalculatorFloat(value)
                return formattedValue
            },

            calculateEffectivePercent() {
                const sortedCashFlow = this._flows.sort((a, b) => a.date - b.date)
                const xirr = ExcelXirr.newtonsMethod(
                    0.1,
                    ExcelXirr.totalFXirr(sortedCashFlow),
                    ExcelXirr.totalDfXirr(sortedCashFlow)
                )
                const effectivePercent = Math.round(xirr * 100) / 100

                return effectivePercent
            },

            getDepositAmountTitle() {
                if (this.isAccumulative) {
                    return this.$phrase('calculators_deposit-initialdeposit')
                }

                return this.$phrase('calculators_deposit-amount')
            },

            _initializeConfiguration() {
                this.enrollmentPeriodsList.push({
                    id: 1,
                    text: this.isCertificate
                        ? this.$phrase('calculators_deposit-certificate-discont')
                        : this.$phrase('calculators_deposit-enrollmentperiod-endofterm')
                })
                this.enrollmentPeriodsList.push({
                    id: 2,
                    text: this.isCertificate
                        ? this.$phrase('calculators_deposit-certificate-percent')
                        : this.$phrase('calculators_deposit-enrollmentperiod-monthly')
                })
                this.enrollmentPeriodsTitle = this.isCertificate
                    ? this.$phrase('calculators_deposit-certificatetitle')
                    : this.$phrase('calculators_deposit-enrollmentperiodtitle');


                this.currencies = [...new Set(this.config.ranges.map(range => range.currency))]

                this.enrollmentPeriod = this.enrollmentPeriodsList[0]
                this._initializeEnrolmentPeriodConfiguration()
            },

            _initializeEnrolmentPeriodConfiguration() {
                this.minTerm = this.config.ranges
                    .filter(range => range.currency === this.currency)
                    .filter(range => range.percentEnrollmentPeriod === this.enrollmentPeriod.id)
                    .reduce((min, range) => range.minTerm < min ? range.minTerm : min, Infinity)

                this.maxTerm = Math.max(...this.config.ranges
                    .filter(range => range.currency === this.currency)
                    .filter(range => range.percentEnrollmentPeriod === this.enrollmentPeriod.id)
                    .map(range => range.maxTerm))

                this.startTerm = parseInt((this.minTerm + this.maxTerm) / 2)

                this.depositAmount = parseInt(this.config.initialAmount)
                this.minDepostAmount = parseInt(this.config.minAmount)
                this.maxDepostAmount = parseInt(this.config.maxAmount)

                this.monthlyTrancheAmount = parseInt(this.config.initialMonthlyTranceAmount)
                this.minMonthlyTrancheAmount = parseInt(this.config.minMonthlyTrancheAmount)
                this.maxMonthlyTrancheAmount = parseInt(this.config.maxMonthlyTranceAmount)

                this.onMeasureUpdated(this.currency)
            }
        },

        computed: {
            totalWithdraw() {
                const totalAmount = this._flows
                    .filter(x =>
                        x.type == ProductCalculatorCashFlowTypes.PercentEnrolment
                        || x.type == ProductCalculatorCashFlowTypes.CashOut)
                    .reduce((sum, x) => sum + x.amount, 0)

                return totalAmount
            },

            percent() {
                const entry = this.config.ranges
                    .find(range =>
                        this.term >= range.minTerm
                        && this.term <= range.maxTerm
                        && this.currency === range.currency
                        && this.enrollmentPeriod.id === range.percentEnrollmentPeriod
                    )

                if (!entry) {
                    return 0
                }

                return entry.percent || 0
            },

            percentAmount() {
                const sumAmount = this._flows
                    .filter(x => x.type == ProductCalculatorCashFlowTypes.PercentEnrolment)
                    .reduce((sum, x) => sum + x.amount, 0)

                return sumAmount
            },

            _flows() {
                const startDay = new Date()
                startDay.setHours(0, 0, 0, 0)

                const endDate = new Date(startDay)
                endDate.setMonth(endDate.getMonth() + this.term)

                const monthCount = 1

                const depositService = new DepositService(
                    this.depositAmount,
                    this.monthlyTrancheAmount,
                    this.percent,
                    startDay,
                    endDate,
                    monthCount,
                    this.enrollmentPeriod.id
                )
                const flows = depositService.calculateFlows()

                return flows
            }
        },

        watch: {
            enrollmentPeriod(newValue, oldValue) {
                this._initializeEnrolmentPeriodConfiguration()
            }
        },

        mounted() {
            UiService.shared.dispatchComponentMountedEvent(this.$el, 'deposit-calculator')
        },

        created() {
            this._initializeConfiguration()
        }
    ,
template: `
    <div class="calculator__content">
        <div class="calculator__item">
            <div class="js-col-controls">
                <calculator-dropdown v-model="enrollmentPeriod" :title="enrollmentPeriodsTitle" :list="enrollmentPeriodsList"></calculator-dropdown>

                <calculator-slider v-model="depositAmount" @update:measure="onMeasureUpdated" :title="getDepositAmountTitle()" :min-value="minDepostAmount" :start-value="depositAmount" :max-value="maxDepostAmount" measure="₾" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')" :dropdown-list="currencies" :hide-slider-controls="true"></calculator-slider>

                <calculator-slider v-if="showMonthlyTrancheInput()" v-model="monthlyTrancheAmount" @update:measure="onMeasureUpdated" :title="$phrase('calculators_deposit-monthlydeposittitle')" :min-value="minMonthlyTrancheAmount" :start-value="monthlyTrancheAmount" :max-value="maxMonthlyTrancheAmount" measure="₾" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')" :hide-slider-controls="true"></calculator-slider>

                <calculator-slider v-model="term" :title="$phrase('calculators_deposit-term')" :min-value="minTerm" :start-value="startTerm" :max-value="maxTerm" :measure="$phrase('calculators_month')" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')"></calculator-slider>
            </div>
        </div>

        <div class="calculator__item">
            <div class="calculator__results js-col-results">
                <div class="calculator__results-info">
                    <span class="calculator__results-label">{{ $phrase('calculators_deposit-totalwithdraw') }}</span>
                    <h4 class="calculator__results-key">{{ formatNumberWithCurrency(totalWithdraw) }}</h4>
                </div>
                <div class="calculator__results-options">
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_deposit-percentamount') }}</span>
                        <p class="calculator__results-options-value">{{ formatNumberWithCurrency(percentAmount) }}</p>
                    </div>
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_deposit-percent') }}</span>
                        <p class="calculator__results-options-value">{{ formatNumber(percent) }}%</p>
                    </div>
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_deposit-effectivepercent') }}</span>
                        <p class="calculator__results-options-value">{{ calculateEffectivePercent() }}%</p>
                    </div>
                </div>
                <div class="calculator__results-actions">
                    <a :href="config.applyUrl" class="button button--primary button--default">
                        <span class="button__text">{{ $phrase('calculators_deposit-opendeposit') }}</span>
                    </a>
                </div>
                <p class="calculator__results-warning" v-html="$phrase('calculators_resultsdisclaimer')"></p>
            </div>
        </div>

    </div>
`
});
Vue.component('ipo-loan-calculator', {
        props: {
            config: {
                type: Object,
                required: true
            }
        },

        emits: [],

        data: function () {
            return {
                estatePrice: null,
                minEstatePrice: null,
                maxEstatePrice: null,
                downPaymentPercent: 0, //null
                minDownPaymentPercent: null,
                maxDownPaymentPercent: null,
                term: null,
                currency: '₾',
                currencies: [],
                minTerm: null,
                maxTerm: null,
                startTerm: null
            }
        },

        methods: {
            onMeasureUpdated(measureVal) {
                this.currency = measureVal
                this._initializeCurrencyConfiguration()
            },

            onShowSchedule() {
                const elem = this.$refs['secure-consumer-load-calculator-schedule']
                Fancybox.show([{ src: elem, type: 'inline' }])
            },

            formatNumberWithCurrency(value) {
                const formattedValue = TextFormattingService.formatCalculatorFloat(value)
                const formattedValueWithCurrency = `${formattedValue}${this.currency}`
                return formattedValueWithCurrency
            },

            formatNumber(value) {
                const formattedValue = TextFormattingService.formatCalculatorFloat(value)
                return formattedValue
            },

            calculateEffectivePercent() {
                const payments = [...this.schedule]
                const effectivePercent = LoanService.shared.calculateEffectivePercent(payments, this.principal)
                const formattedPercent = TextFormattingService.formatCalculatorFloat(effectivePercent)
                return formattedPercent
            },

            _initializeConfiguration() {
                this.currencies = [...new Set(this.config.ranges.map(rate => rate.currency))]

                this.estatePrice = parseInt(this.config.initialAmount)
                this.minEstatePrice = parseInt(this.config.minAmount)
                this.maxEstatePrice = parseInt(this.config.maxAmount)

                //this.downPaymentPercent = parseInt(this.config.initialDownPaymentPercent)
                this.minDownPaymentPercent = parseInt(this.config.minDownPaymentPercent)
                this.maxDownPaymentPercent = parseInt(this.config.maxDownPaymentPercent)

                this._initializeCurrencyConfiguration()
            },

            _initializeCurrencyConfiguration() {
                this.minTerm = this.config.ranges
                    .filter(rate => rate.currency === this.currency)
                    .reduce((min, rate) => rate.minTerm < min ? rate.minTerm : min, Infinity)

                this.maxTerm = Math.max(...this.config.ranges
                    .filter(rate => rate.currency === this.currency)
                    .map(rate => rate.maxTerm))

                const initialTerm = this.config.ranges.filter(rate => rate.currency === this.currency)[0].initialTerm;
                this.startTerm = initialTerm >= this.minTerm && initialTerm <= this.maxTerm
                    ? initialTerm
                    : parseInt((this.minTerm + this.maxTerm) / 2)
            }
        },

        computed: {
            principal() {
                const principal = this.estatePrice * (1 - this.downPaymentPercent / 100)
                return Math.max(0, principal)
            },

            schedule() {
                const payments = LoanService.shared.calculateLoanPayments(this.principal, this.percent, this.term)
                return payments
            },

            monthlyPaymentAmount() {
                if (!this.schedule || !this.schedule.length) {
                    return ''
                }

                const amount = parseFloat(this.schedule[0].monthlyPayment)
                const formattedAmount = TextFormattingService.formatCalculatorFloat(amount)
                return formattedAmount
            },

            percent() {
                const entry = this.config.ranges
                    .find(rate =>
                        this.term >= rate.minTerm
                        && this.term <= rate.maxTerm
                        && rate.currency === this.currency
                    )

                if (!entry) {
                    return 0
                }

                return entry.percent || 0;
            }
        },

        mounted() {
            UiService.shared.dispatchComponentMountedEvent(this.$el, 'ipo-loan-calculator')
        },

        created() {
            this._initializeConfiguration()
        }
    ,
template: `

    <div class="calculator__content">
        <div class="calculator__item">
            <div class="js-col-controls">
                <calculator-slider v-model="estatePrice" @update:measure="onMeasureUpdated" :title="$phrase('calculators_ipo-estateprice')" :min-value="minEstatePrice" :start-value="estatePrice" :max-value="maxEstatePrice" measure="₾" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')" :dropdown-list="currencies" :hide-slider-controls="true"></calculator-slider>

                <!--<calculator-slider v-model="downPaymentPercent" :title="$phrase('calculators_ipo-downpayment')" :min-value="minDownPaymentPercent" :start-value="downPaymentPercent" :max-value="maxDownPaymentPercent" measure="%" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')"></calculator-slider>-->

                <calculator-slider v-model="term" :title="$phrase('calculators_ipo-term')" :min-value="minTerm" :start-value="startTerm" :max-value="maxTerm" :measure="$phrase('calculators_month')" :min-prefix="$phrase('calculators_minlabel')" :max-prefix="$phrase('calculators_maxlabel')"></calculator-slider>
            </div>
        </div>

        <div class="calculator__item">
            <div class="calculator__results js-col-results">
                <div class="calculator__results-info">
                    <span class="calculator__results-label">{{ $phrase('calculators_ipo-result-monthlypayment') }}</span>
                    <h4 class="calculator__results-key">{{ monthlyPaymentAmount }}{{ currency }}</h4>
                </div>
                <div class="calculator__results-options">
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_ipo-result-annualpercent') }}</span>
                        <p class="calculator__results-options-value">{{ formatNumber(percent) }}%{{ $phrase('calculators_ipo-result-annualpercentsuffix') }}</p>
                    </div>
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_ipo-result-effectivepercent') }}</span>
                        <p class="calculator__results-options-value">{{ calculateEffectivePercent() }}%{{ $phrase('calculators_ipo-result-effectivepercentsuffix') }}</p>
                    </div>
                    <div class="calculator__results-options-item">
                        <span class="calculator__results-options-key">{{ $phrase('calculators_ipo-result-term') }}</span>
                        <p class="calculator__results-options-value">{{ term }} {{ $phrase('calculators_month') }}</p>
                    </div>
                </div>
                <div class="calculator__results-actions">
                    <a :href="config.applyUrl" class="button button--primary button--default">
                        <span class="button__text">{{ $phrase('calculators_ipo-result-applyonline') }}</span>
                    </a>
                    <a href="javscript:void(0)" class="button button--primary-reverse button--default"
                       @click.prevent="onShowSchedule()">
                        <span class="button__text">{{ $phrase('calculators_ipo-result-viewschedule') }}</span>
                    </a>
                </div>
                <p class="calculator__results-warning" v-html="$phrase('calculators_resultsdisclaimer')"></p>
            </div>
        </div>
    </div>

    <div class="dialog-content" ref="secure-consumer-load-calculator-schedule" style="display: none;">
        <div class="dialog-content__head">
            <h3 class="dialog-content__title">{{$phrase('calculators_schedule-title') }}</h3>
        </div>
        <div class="dialog-content__body">
            <div class="page-text">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>
                                    <p>#</p>
                                </th>
                                <th>
                                    <p>{{$phrase('calculators_schedule-principal') }}</p>
                                </th>
                                <th>
                                    <p>{{$phrase('calculators_schedule-interest') }}</p>
                                </th>
                                <th>
                                    <p>{{$phrase('calculators_schedule-monthlypayment') }}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="payment in schedule">
                                <td>
                                    <p>{{ payment.paymentNumber }}</p>
                                </td>
                                <td>
                                    <p>{{ formatNumberWithCurrency(payment.principalAmount) }}</p>
                                </td>
                                <td>
                                    <p>{{ formatNumberWithCurrency(payment.interestAmount) }}</p>
                                </td>
                                <td>
                                    <p>{{ formatNumberWithCurrency(payment.monthlyPayment) }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


`
});
Vue.component('card-compare', {
        props: {},
        data: function () {
            return {
                cards: [],
                selectedCards: [],
                cardsWithoutSelected: [],
                filteredCards: [],
                keyword: '',
                attributes: [],
                settings: {
                    showModal: false,
                    showAddNewItem: true
                }
            };
        },
        methods: {
            filterCards() {
                var _this = this;

                _this.filteredCards = _this.cardsWithoutSelected.filter(function (card) {
                    return card.title.toLowerCase().includes(_this.keyword.toLowerCase());
                });

            },
            removeItemFromCompare(card) {
                var _this = this;
                _this.selectedCards = _this.selectedCards.filter(function (item) {
                    return item.id != card.id;
                });

                _this.settings.showAddNewItem = _this.selectedCards.length < 3;

                _this.cardsWithoutSelected = _this.cards.filter(item => !_this.selectedCards.includes(item));
                _this.filterCards();
            },
            closeModal() {
                var _this = this;
                _this.settings.showModal = false;
                $('body').toggleClass('noscroll', false);
            },
            openCompareModal(productId) {
                var _this = this;
                if (_this.cards.length == 0) {
                    return;
                }
                _this.settings.showModal = true;
                $('body').toggleClass('noscroll', true);
                _this.selectedCards = [];
                var selectedCardId = parseInt(productId);
                _this.selectCard(selectedCardId);
            },
            selectCard(cardId) {
                var _this = this;
                var selectedCard = _this.cards.filter(function (card) {
                    return card.id == cardId;
                });

                _this.selectedCards.push(selectedCard[0]);

                _this.settings.showAddNewItem = _this.selectedCards.length < 3;


                _this.cardsWithoutSelected = _this.cards.filter(item => !_this.selectedCards.includes(item));
                _this.filterCards();

                $('.compare__product-dropdown').removeClass('open');
                $('.js-results').hide();
                _this.keyword = '';
            },
            getCardAttributeValue(cardId, attributeId) {
                var _this = this;
                var card = _this.selectedCards.filter(function (card) {
                    return card.id == cardId;
                });
                var attribute = card[0].attributes.filter(function (attr) {
                    return attr.id == attributeId;
                });

                return attribute[0].value ?? "-";
            },
            getCards() {
                var _this = this;
                var endpointUrl = window._data.apiBaseUrl + 'CompareApi/GetCards';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr,
                        pageId: window._data.pageId
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.cards = response.data.data.cards;
                            _this.attributes = _this.cards[0].attributes;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },
        mounted() {
            this.getCards()

            UiService.shared.attachOpenCompareModalEvent('card', (e) => {
                this.openCompareModal(e.detail.productId)
            })

        }
    ,
template: `

    <div class="compare " style="display:block" v-show="settings.showModal">
        <div class="container">
            <div class="compare__content">
                <div class="compare__head">
                    <h2 class="compare__title">{{$phrase('cardcompare_title')}}</h2>
                    <a href="" class="compare__close" @click.prevent="closeModal()">
                        <svg class="compare__close-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </a>
                </div>
                <div class="compare__body">
                    <div class="compare__table">
                        <div class="compare__table-row compare__table-row--head">
                            <div class="compare__table-cell">
                                <div class="compare__table-cell-inner">
                                    <h3 class="compare__table-cell-title">{{$phrase('cardcompare_conditions')}}</h3>
                                </div>
                            </div>
                            <div class="compare__table-cell" v-for="item in selectedCards">
                                <div class="compare__table-cell-inner">
                                    <div class="compare__product">
                                        <a href="" class="compare__product-delete" @click.prevent="removeItemFromCompare(item)">
                                            <svg class="compare__product-delete-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                            </svg>
                                        </a>
                                        <div class="compare__product-media">
                                            <img v-bind:src="item.imageUrl" alt="">
                                        </div>
                                        <div class="compare__product-text">
                                            <h4 class="compare__product-title">{{item.title}}</h4>

                                            <div class="compare__product-actions" v-if="item.url != null && item.url.length > 0">
                                                <a :href="item.url" target="_blank" class="button button--small button--primary-reverse">
                                                    <span class="button__text">{{$phrase('cardcompare_orderbuttontitle')}}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="compare__table-cell" v-show="settings.showAddNewItem && cardsWithoutSelected.length > 0">
                                <div class="compare__table-cell-inner">
                                    <div class="compare__product compare__product--empty">
                                        <div class="compare__product-media">
                                            <svg class="compare__product-media-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                            </svg>
                                        </div>
                                        <div class="compare__product-text">
                                            <div class="compare__product-dropdown">
                                                <a href="" class="button button--link button--link-primary js-trigger">
                                                    <span class="button__text">{{$phrase('cardcompare_selectcard')}}</span>
                                                </a>
                                                <div class="compare__product-dropdown-results js-results">
                                                    <div class="compare__product-dropdown-results-content">
                                                        <div class="compare__product-dropdown-results-search">
                                                            <div class="compare__product-dropdown-results-search-field-wrap">
                                                                <input type="text" class="compare__product-dropdown-results-search-field"
                                                                       :placeholder="$phrase('cardcompare_searchplaceholder')"
                                                                       :aria-label="$phrase('cardcompare_searchplaceholder')"
                                                                       v-model="keyword"
                                                                       @input="filterCards()">
                                                                <a href="" class="compare__product-dropdown-results-search-search-action">
                                                                    <svg class="compare__product-dropdown-results-search-search-action-icon">
                                                                        <use xlink:href="~/m/i/icons.svg#symbol-magnifier"></use>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="compare__product-dropdown-results-item-list">
                                                            <a href="" class="compare__product-dropdown-results-item" v-for="card in filteredCards"
                                                               @click.prevent="selectCard(card.id)">
                                                                <div class="compare__product-dropdown-results-item-media">
                                                                    <img v-bind:src="card.imageUrl" alt="">
                                                                </div>
                                                                <span class="compare__product-dropdown-results-item-text">{{card.title}}</span>
                                                            </a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="compare__table-row" v-for="attr in attributes">
                            <div class="compare__table-cell">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">{{attr.title}}</p>
                                </div>
                            </div>
                            <div class="compare__table-cell" v-for="card in selectedCards">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">{{getCardAttributeValue(card.id, attr.id)}}</p>
                                </div>
                            </div>

                            <div class="compare__table-cell" v-show="settings.showAddNewItem && cardsWithoutSelected.length > 0">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">---</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('deposit-compare', {
        props: {},
        data: function () {
            return {
                deposits: [],
                selectedDeposits: [],
                depositsWithoutSelected: [],
                filteredDeposits: [],
                keyword: '',
                attributes: [],
                settings: {
                    showModal: false,
                    showAddNewItem: true
                }
            };
        },
        methods: {
            filterDeposits() {
                var _this = this;

                _this.filteredDeposits = _this.depositsWithoutSelected.filter(function (deposit) {
                    return deposit.title.toLowerCase().includes(_this.keyword.toLowerCase());
                });

            },
            removeItemFromCompare(deposit) {
                var _this = this;
                _this.selectedDeposits = _this.selectedDeposits.filter(function (item) {
                    return item.id != deposit.id;
                });

                _this.settings.showAddNewItem = _this.selectedDeposits.length < 3;

                _this.depositsWithoutSelected = _this.deposits.filter(item => !_this.selectedDeposits.includes(item));
                _this.filterDeposits();
            },
            closeModal() {
                var _this = this;
                _this.settings.showModal = false;
                $('body').toggleClass('noscroll', false);
            },
            openCompareModal(productId) {
                var _this = this;
                if (_this.deposits.length == 0) {
                    return;
                }
                _this.settings.showModal = true;
                $('body').toggleClass('noscroll', true);
                _this.selectedDeposits = [];
                var selectedDepositId = parseInt(productId);
                _this.selectDeposit(selectedDepositId);
            },
            selectDeposit(depositId) {
                var _this = this;
                var selectedDeposit = _this.deposits.filter(function (deposit) {
                    return deposit.id == depositId;
                });

                _this.selectedDeposits.push(selectedDeposit[0]);

                _this.settings.showAddNewItem = _this.selectedDeposits.length < 3;


                _this.depositsWithoutSelected = _this.deposits.filter(item => !_this.selectedDeposits.includes(item));
                _this.filterDeposits();

                $('.compare__product-dropdown').removeClass('open');
                $('.js-results').hide();
                _this.keyword = '';
            },
            getDepositAttributeValue(depositId, attributeId) {
                var _this = this;
                var deposit = _this.selectedDeposits.filter(function (deposit) {
                    return deposit.id == depositId;
                });
                var attribute = deposit[0].attributes.filter(function (attr) {
                    return attr.id == attributeId;
                });

                return attribute[0].value ?? "-";
            },
            getDeposits() {
                var _this = this;
                var endpointUrl = window._data.apiBaseUrl + 'CompareApi/GetDeposits';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr,
                        pageId: window._data.pageId
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.deposits = response.data.data.deposits;
                            _this.attributes = _this.deposits[0].attributes;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },
        mounted() {
            this.getDeposits()

            UiService.shared.attachOpenCompareModalEvent('deposit', (e) => {
                this.openCompareModal(e.detail.productId)
            })
        }
    ,
template: `

    <div class="compare " style="display:block" v-show="settings.showModal">
        <div class="container">
            <div class="compare__content">
                <div class="compare__head">
                    <h2 class="compare__title">{{$phrase('depositcompare_title')}}</h2>
                    <a href="" class="compare__close" @click.prevent="closeModal()">
                        <svg class="compare__close-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </a>
                </div>
                <div class="compare__body">
                    <div class="compare__table">
                        <div class="compare__table-row compare__table-row--head">
                            <div class="compare__table-cell">
                                <div class="compare__table-cell-inner">
                                    <h3 class="compare__table-cell-title">{{$phrase('depositcompare_conditions')}}</h3>
                                </div>
                            </div>
                            <div class="compare__table-cell" v-for="item in selectedDeposits">
                                <div class="compare__table-cell-inner">
                                    <div class="compare__product">
                                        <a href="" class="compare__product-delete" @click.prevent="removeItemFromCompare(item)">
                                            <svg class="compare__product-delete-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                            </svg>
                                        </a>
                                        <div class="compare__product-media">
                                            <img v-bind:src="item.imageUrl" alt="">
                                        </div>
                                        <div class="compare__product-text">
                                            <h4 class="compare__product-title">{{item.title}}</h4>

                                            <div class="compare__product-actions" v-if="item.url != null && item.url.length > 0">
                                                <a :href="item.url" target="_blank" class="button button--small button--primary-reverse">
                                                    <span class="button__text">{{$phrase('depositcompare_orderbuttontitle')}}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="compare__table-cell" v-show="settings.showAddNewItem && depositsWithoutSelected.length > 0">
                                <div class="compare__table-cell-inner">
                                    <div class="compare__product compare__product--empty">
                                        <div class="compare__product-media">
                                            <svg class="compare__product-media-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                            </svg>
                                        </div>
                                        <div class="compare__product-text">
                                            <div class="compare__product-dropdown">
                                                <a href="" class="button button--link button--link-primary js-trigger">
                                                    <span class="button__text">{{$phrase('depositcompare_selectdeposit')}}</span>
                                                </a>
                                                <div class="compare__product-dropdown-results js-results">
                                                    <div class="compare__product-dropdown-results-content">
                                                        <div class="compare__product-dropdown-results-search">
                                                            <div class="compare__product-dropdown-results-search-field-wrap">
                                                                <input type="text" class="compare__product-dropdown-results-search-field"
                                                                       :placeholder="$phrase('depositcompare_searchplaceholder')"
                                                                       :aria-label="$phrase('depositcompare_searchplaceholder')"
                                                                       v-model="keyword"
                                                                       @input="filterDeposits()">
                                                                <a href="" class="compare__product-dropdown-results-search-search-action">
                                                                    <svg class="compare__product-dropdown-results-search-search-action-icon">
                                                                        <use xlink:href="~/m/i/icons.svg#symbol-magnifier"></use>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="compare__product-dropdown-results-item-list">
                                                            <a href="" class="compare__product-dropdown-results-item" v-for="deposit in filteredDeposits"
                                                               @click.prevent="selectDeposit(deposit.id)">
                                                                <div class="compare__product-dropdown-results-item-media">
                                                                    <img v-bind:src="deposit.imageUrl" alt="">
                                                                </div>
                                                                <span class="compare__product-dropdown-results-item-text">{{deposit.title}}</span>
                                                            </a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="compare__table-row" v-for="attr in attributes">
                            <div class="compare__table-cell">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">{{attr.title}}</p>
                                </div>
                            </div>
                            <div class="compare__table-cell" v-for="deposit in selectedDeposits">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">{{getDepositAttributeValue(deposit.id, attr.id)}}</p>
                                </div>
                            </div>

                            <div class="compare__table-cell" v-show="settings.showAddNewItem && depositsWithoutSelected.length > 0">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">---</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('loan-compare', {
        props: {},
        data: function () {
            return {
                loans: [],
                selectedLoans: [],
                loansWithoutSelected: [],
                filteredLoans: [],
                keyword: '',
                attributes: [],
                settings: {
                    showModal: false,
                    showAddNewItem: true
                },
                isOpen: false,
            };
        },
        methods: {
            getSelectedType(loan) {
                var selectedType = loan.types.filter(function (type) {
                    return type.selected;
                });

                return selectedType[0].title;
            },
            selectLoanType(loan, type) {
                loan.types.forEach(function (item) {
                    item.selected = false;
                });

                type.selected = true;
                this._closeList(loan.id)
            },
            filterLoans() {
                var _this = this;

                _this.filteredLoans = _this.loansWithoutSelected.filter(function (loan) {
                    return loan.title.toLowerCase().includes(_this.keyword.toLowerCase());
                });

            },
            removeItemFromCompare(loan) {
                var _this = this;
                _this.selectedLoans = _this.selectedLoans.filter(function (item) {
                    return item.id != loan.id;
                });

                _this.settings.showAddNewItem = _this.selectedLoans.length < 3;

                _this.loansWithoutSelected = _this.loans.filter(item => !_this.selectedLoans.includes(item));
                _this.filterLoans();
            },
            closeModal() {
                var _this = this;
                _this.settings.showModal = false;
                $('body').toggleClass('noscroll', false);
            },
            openCompareModal(productId) {
                var _this = this;
                if (_this.loans.length == 0) {
                    return;
                }
                _this.settings.showModal = true;
                $('body').toggleClass('noscroll', true);
                _this.selectedLoans = [];
                var selectedLoanId = parseInt(productId);
                _this.selectLoan(selectedLoanId);
            },
            selectLoan(loanId) {
                var _this = this;
                var selectedLoan = _this.loans.filter(function (loan) {
                    return loan.id == loanId;
                });

                _this.selectedLoans.push(selectedLoan[0]);

                _this.settings.showAddNewItem = _this.selectedLoans.length < 3;


                _this.loansWithoutSelected = _this.loans.filter(item => !_this.selectedLoans.includes(item));
                _this.filterLoans();

                $('.compare__product-dropdown').removeClass('open');
                $('.js-results').hide();
                _this.keyword = '';
            },
            getLoanAttributeValue(loan, type, attributeId) {
                var _this = this;
                //var loan = _this.selectedLoans.filter(function (loan) {
                //    return loan.id == loanId;
                //});
                //var attribute = loan[0].attributes.filter(function (attr) {
                //    return attr.id == attributeId;
                //});

                var attribute = type.attributes.filter(function (attr) {
                    return attr.id == attributeId;
                });

                return attribute[0].value ?? "-";
            },
            getLoans() {
                var _this = this;
                _this.attributes = [];
                var endpointUrl = window._data.apiBaseUrl + 'CompareApi/GetLoans';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr,
                        pageId: window._data.pageId
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.loans = response.data.data.loans;

                            _this.loans[0].types[0].attributes.forEach(function (type) {
                                _this.attributes.push(type);
                            });

                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            },

            onOpenRequest(item) {
                if (this.isOpen) {
                    this._closeList(item.id)
                }
                else {
                    this._openList(item.id)
                }
            },

            _closeList(index) {
                this.isOpen = false;
                $(this.$refs[`list${index}`]).stop().slideUp('fast')
            },

            _openList(index) {
                this.isOpen = true
                $(this.$refs[`list${index}`]).stop().slideDown('fast')
            }
        },
        mounted() {
            this.getLoans()

            UiService.shared.attachOpenCompareModalEvent('loan', (e) => {
                this.openCompareModal(e.detail.productId)
            })
        }
    ,
template: `

    <div class="compare " style="display:block" v-show="settings.showModal">
        <div class="container">
            <div class="compare__content">
                <div class="compare__head">
                    <h2 class="compare__title">{{$phrase('loancompare_title')}}</h2>
                    <a href="" class="compare__close" @click.prevent="closeModal()">
                        <svg class="compare__close-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </a>
                </div>
                <div class="compare__body">
                    <div class="compare__table">
                        <div class="compare__table-row compare__table-row--head">
                            <div class="compare__table-cell">
                                <div class="compare__table-cell-inner">
                                    <h3 class="compare__table-cell-title">{{$phrase('loancompare_conditions')}}</h3>
                                </div>
                            </div>
                            <div class="compare__table-cell" v-for="item in selectedLoans">
                                <div class="compare__table-cell-inner">
                                    <div class="compare__product">
                                        <a href="" class="compare__product-delete" @click.prevent="removeItemFromCompare(item)">
                                            <svg class="compare__product-delete-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                            </svg>
                                        </a>
                                        <div class="compare__product-media">
                                            <img v-bind:src="item.imageUrl" alt="">
                                        </div>
                                        <div class="compare__product-text">
                                            <h4 class="compare__product-title">{{item.title}}</h4>
                                            <div class="compare__product-dropdown" v-if="item.types.length > 1">
                                                <a href="" class="compare__product-dropdown-trigger js-trigger" @click.prevent="onOpenRequest(item)">
                                                    <span class="compare__product-dropdown-trigger-text">{{getSelectedType(item)}}</span>
                                                    <div class="compare__product-dropdown-trigger-icon-wrap">
                                                        <svg class="compare__product-dropdown-trigger-icon">
                                                            <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                                        </svg>
                                                    </div>
                                                </a>
                                                <div class="compare__product-dropdown-results" :ref="'list' + item.id">
                                                    <div class="compare__product-dropdown-results-content">
                                                        <div class="compare__product-dropdown-results-item-list">
                                                            <a href="" class="compare__product-dropdown-results-item" v-for="type in item.types" @click.prevent="selectLoanType(item, type)">
                                                                <span class="compare__product-dropdown-results-item-text">{{type.title}}</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="compare__product-actions" v-for="type in item.types">
                                                <a :href="type.url" target="_blank" class="button button--small button--primary-reverse" v-if="type.selected && type.url != null && type.url.length > 0">
                                                    <span class="button__text">{{$phrase('cardcompare_orderbuttontitle')}}</span>
                                                </a>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="compare__table-cell" v-show="settings.showAddNewItem && loansWithoutSelected.length > 0">
                                <div class="compare__table-cell-inner">
                                    <div class="compare__product compare__product--empty">
                                        <div class="compare__product-media">
                                            <svg class="compare__product-media-icon">
                                                <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                                            </svg>
                                        </div>
                                        <div class="compare__product-text">
                                            <div class="compare__product-dropdown">
                                                <a href="" class="button button--link button--link-primary js-trigger">
                                                    <span class="button__text">{{$phrase('loancompare_selectloan')}}</span>
                                                </a>
                                                <div class="compare__product-dropdown-results js-results">
                                                    <div class="compare__product-dropdown-results-content">
                                                        <div class="compare__product-dropdown-results-search">
                                                            <div class="compare__product-dropdown-results-search-field-wrap">
                                                                <input type="text" class="compare__product-dropdown-results-search-field"
                                                                       :placeholder="$phrase('loancompare_searchplaceholder')"
                                                                       :aria-label="$phrase('loancompare_searchplaceholder')"
                                                                       v-model="keyword"
                                                                       @input="filterLoans()">
                                                                <a href="" class="compare__product-dropdown-results-search-search-action">
                                                                    <svg class="compare__product-dropdown-results-search-search-action-icon">
                                                                        <use xlink:href="~/m/i/icons.svg#symbol-magnifier"></use>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="compare__product-dropdown-results-item-list">
                                                            <a href="" class="compare__product-dropdown-results-item" v-for="loan in filteredLoans"
                                                               @click.prevent="selectLoan(loan.id)">
                                                                <div class="compare__product-dropdown-results-item-media">
                                                                    <img v-bind:src="loan.imageUrl" alt="">
                                                                </div>
                                                                <span class="compare__product-dropdown-results-item-text">{{loan.title}}</span>
                                                            </a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="compare__table-row" v-for="attr in attributes">
                            <div class="compare__table-cell">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">{{attr.title}}</p>
                                </div>
                            </div>
                            <div class="compare__table-cell" v-for="loan in selectedLoans">
                                <div class="compare__table-cell-inner" v-for="type in loan.types">
                                    <p class="compare__table-cell-text" v-show="type.selected">{{getLoanAttributeValue(loan, type, attr.id)}}</p>
                                </div>
                            </div>

                            <div class="compare__table-cell" v-show="settings.showAddNewItem && loansWithoutSelected.length > 0">
                                <div class="compare__table-cell-inner">
                                    <p class="compare__table-cell-text">---</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('currency-rates-calculator', {
        props: {},

        data: function () {
            return {
                rates: {},
                currencies: [],
                currencyFrom: '',
                currencyTo: '',
                calculateUsingFrom: true,
                mounted: false,
                loaded: false,
                currencyTexts: {
                    USD: {
                        prefix: "$",
                        suffix: "",
                    },
                    GBP: {
                        prefix: "£",
                        suffix: "",
                    },
                    EUR: {
                        prefix: "€",
                        suffix: "",
                    },
                    GEL: {
                        prefix: "",
                        suffix: "₾",
                    },
                    default: {
                        prefix: "",
                        suffix: "",
                    }
                }
            }
        },

        methods: {
            getToAmountOfOneAmountOfFrom() {
                if (!this.rates) {
                    return ""
                }

                if (!this.rates[this.currencyFrom]) {
                    return ""
                }

                if (!this.rates[this.currencyFrom][this.currencyTo]) {
                    return ""
                }

                return (this.rates[this.currencyFrom][this.currencyTo]).toFixed(4)
            },

            getCurrencyUnitValue(currency, amount) {
                var texts = this.currencyTexts[currency]
                if (!texts) {
                    texts = this.currencyTexts.default
                }

                return texts.prefix + '' + amount + '' + texts.suffix
            },

            onInputFrom() {
                this.calculateUsingFrom = true
                this._calculateResult()
            },

            onInputTo() {
                this.calculateUsingFrom = false
                this._calculateResult()
            },

            onKeyPressFrom(e) {
                if (this._inputKeyIsAllowed(e)) {
                    return
                }

                e.preventDefault()
                e.stopPropagation()
            },

            onKeyPressTo(e) {
                if (this._inputKeyIsAllowed(e)) {
                    return
                }

                e.preventDefault()
                e.stopPropagation()
            },

            onPaste(e) {
                const clipboardData = e.clipboardData || window.clipboardData
                const pastedData = clipboardData.getData('text')
                const target = e.target
                const cursorPosition = target.selectionStart
                const currentValue = target.value
                const selectionEnd = target.selectionEnd
                const selectionLength = selectionEnd - cursorPosition

                if (!/^\d*\.?\d*$/.test(pastedData) || (pastedData.split('.').length > 2)) {
                    e.preventDefault()
                    return
                }

                const newValue = currentValue.slice(0, cursorPosition) + pastedData + currentValue.slice(selectionEnd)
                const parts = newValue.split('.')
                const integerPart = parts[0]
                const fractionPart = parts.length > 1 ? parts[1] : ''

                if (integerPart.length > 9 || (fractionPart.length > 2)) {
                    e.preventDefault()
                    return
                }
            },

            swapCurrencies() {
                this.currencyFrom = this.currencyTo
                // !imprtant: 'currencyFrom' watcher will handle the the invese assignment, no need to assign backwards here
            },

            _inputKeyIsAllowed(e) {
                if (e.altKey || e.ctrlKey || !e.charCode) {
                    return false
                }

                const keyCode = e.keyCode
                const target = e.target
                const currentValue = target.value
                const cursorPosition = target.selectionStart
                const selectionEnd = target.selectionEnd
                const selectionLength = selectionEnd - cursorPosition

                if (keyCode != 46 && (keyCode < 48 || keyCode > 57)) {
                    return false
                }

                if (keyCode == 46 && currentValue.includes('.') && selectionLength === 0) {
                    return false
                }

                const parts = currentValue.split('.')
                let integerPart = parts[0]
                let fractionPart = parts.length > 1 ? parts[1] : ''

                if (selectionLength > 0 && cursorPosition <= integerPart.length) {
                    if (selectionEnd <= integerPart.length) {
                        integerPart = integerPart.substring(0, cursorPosition) + integerPart.substring(selectionEnd)
                    } else if (cursorPosition < integerPart.length) {
                        integerPart = integerPart.substring(0, cursorPosition)
                        fractionPart = fractionPart.substring(selectionEnd - integerPart.length)
                    } else {
                        fractionPart = fractionPart.substring(0, cursorPosition - integerPart.length - 1) + fractionPart.substring(selectionEnd - integerPart.length - 1)
                    }
                }

                if ((integerPart.length >= 10 && cursorPosition <= integerPart.length && selectionLength === 0) ||
                    (fractionPart.length >= 2 && cursorPosition > integerPart.length && selectionLength === 0)) {
                    return false
                }

                return true
            },

            _calculateResult() {
                if (this.calculateUsingFrom) {
                    this._calculateUsingFrom()
                    return
                }

                this._calculateUsingTo()
            },

            _calculateUsingFrom() {
                const result = CurrencyRatesService.shared.calculateRateUsingFrom(
                    this.$refs.from.value,
                    this.currencyFrom,
                    this.currencyTo
                )

                this.$refs.to.value = result.toFixed(2)
            },

            _calculateUsingTo() {
                const result = CurrencyRatesService.shared.calculateRateUsingTo(
                    this.$refs.to.value,
                    this.currencyFrom,
                    this.currencyTo
                )

                this.$refs.from.value = result.toFixed(2)
            },

            _calculateInitialValues() {
                if (!this.mounted || !this.loaded) {
                    return
                }
                this._calculateUsingFrom()
            }
        },

        watch: {
            currencyFrom(newVal, oldVal) {
                if (newVal == this.currencyTo) {
                    this.currencyTo = oldVal
                    return
                }

                this._calculateResult()
            },

            currencyTo(newVal, oldVal) {
                if (newVal == this.currencyFrom) {
                    this.currencyFrom = oldVal
                    return
                }

                this._calculateResult()
            }
        },

        mounted() {
            this.mounted = true
            this.$refs.from.value = "100"
            this._calculateInitialValues()
        },

        async created() {
            const {
                currencies: allCurrencies,
                rates: allRates
            } = await CurrencyRatesService.shared.getTeraCrossRatesForConverterFull()

            this.currencies = allCurrencies
            this.rates = allRates

            if (this.currencies.length > 2) {
                this.currencyFrom = this.currencies[0]
                this.currencyTo = this.currencies[1]
            }

            this.loaded = true

            this._calculateInitialValues()
        }
    ,
template: `
    <div class="currencies-block__item">
        <div class="currencies-block__item-head">
            <h4 class="currencies-block__item-title">{{ $phrase('currencies_converter-title') }}</h4>
        </div>
        <div class="currencies-block__item-body">
            <div class="currencies-block__convertor">
                <div class="currencies-block__convertor-content">
                    <div class="currencies-block__convertor-item">
                        <label for="" class="currencies-block__convertor-label">{{ $phrase('currencies_sell') }}</label>
                        <input type="text" class="currencies-block__convertor-field" :placeholder="$phrase('currencies_converter-enteramount')"
                               ref="from"
                               @input="onInputFrom"
                               @keypress="onKeyPressFrom"
                               @paste="onPaste">
                        <currency-selector :currencies="currencies" v-model="currencyFrom"></currency-selector>
                    </div>

                    <a href="" class="currencies-block__convertor-swap"
                       @click.prevent="swapCurrencies()">
                        <svg class="currencies-block__convertor-swap-icon">
                            <use xlink:href="~/m/i/icons.svg#symbol-swap"></use>
                        </svg>
                    </a>

                    <div class="currencies-block__convertor-item">
                        <label for="" class="currencies-block__convertor-label">{{ $phrase('currencies_buy') }}</label>
                        <input type="text" class="currencies-block__convertor-field" :placeholder="$phrase('currencies_converter-enteramount')"
                               ref="to"
                               @input="onInputTo"
                               @keypress="onKeyPressTo"
                               @paste="onPaste">
                        <currency-selector :currencies="currencies" v-model="currencyTo"></currency-selector>
                    </div>
                </div>
                <div class="currencies-block__convertor-actions">
                    <span class="currencies-block__current-exchange-rate">
                        {{ $phrase('currencies_converter-standardrate') }} {{ getCurrencyUnitValue(currencyFrom, 1) }} = {{ getCurrencyUnitValue(currencyTo, getToAmountOfOneAmountOfFrom()) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('currency-rates-list', {
        props: {
            showHeader: {
                type: Boolean,
                default: false
            }
        },

        data: function () {
            return {
                nbgRates: [],
                crossRates: {},
                currencyTexts: {
                    USD: {
                        unit: "1",
                        Name: "US DOLLAR"
                    },
                    GBP: {
                        unit: "1",
                        Name: "BRITISH STERLING"
                    },
                    EUR: {
                        unit: "1",
                        Name: "EURO"
                    },
                    GEL: {
                        unit: "1",
                        Name: "GEORGIAN LARI"
                    },
                    default: {
                        unit: "",
                        Name: ""
                    }
                }
            }
        },

        methods: {
            getCurrencyIsoName(rate) {
                return (rate.iso || "").toUpperCase()
            },

            getNbgChangeClasses(rate) {
                return {
                    'currencies-list__currency-rate-state--up': rate.nbgOfficialRateChange > 0,
                    'currencies-list__currency-rate-state--down': rate.nbgOfficialRateChange < 0
                }
            },

            getTeraCrossRate(iso, rateTypeName) {
                const rateEntry = this.crossRates[iso] || {};
                const rateValue = rateEntry[rateTypeName] || 0;
                return rateValue.toFixed(4)
            
            },

            getCurrencyUnitAndName(currency) {
                var texts = this.currencyTexts[currency];
                if (!texts) {
                    texts = this.currencyTexts.default;
                }

                return texts.unit + ' ' + texts.Name;
            },

            showCurrencyPrevValue(currency) {
                const rateEntry = this.crossRates[currency] || {};
                const show = rateEntry["showPreviosDayRates"] || false;
                return show;
            }
        },

        mounted() {

        },

        created() {
            CurrencyRatesService.shared.getNbgRates()
                .then((data) => {
                    this.nbgRates = data
                })

            CurrencyRatesService.shared.getTeraCrossRates()
                .then((data) => {
                    data.forEach(item => {
                        this.crossRates[item.iso.toUpperCase()] = item
                    });
                })
        }
    ,
template: `
    <div class="currencies-block__item">

        <div class="currencies-block__item-head"
             v-if="showHeader">
            <h4 class="currencies-block__item-title">{{ $phrase('currencies_list-title') }}</h4>
            <a href="/retail/exchangerates" class="button button--link button--link-primary">
                <span class="button__text">{{ $phrase('currencies_list-all') }}</span>
                <svg class="button__icon button__icon--chevron-right">
                    <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                </svg>
            </a>
        </div>

        <div class="currencies-block__item-body">
            <div class="currencies-list">
                <div class="currencies-list__head">
                    <div class="currencies-list__item">
                        <div class="currencies-list__currency">
                            <span class="currencies-list__th">{{ $phrase('currencies_officialrate') }}</span>
                        </div>
                        <div class="currencies-list__rates">
                            <span class="currencies-list__th">{{ $phrase('currencies_terabankrate') }}</span>
                        </div>
                    </div>
                </div>

                <div class="currencies-list__body">
                    <div class="currencies-list__item"
                         v-for="rate in nbgRates" :key="rate.iso">

                        <div class="currencies-list__currency">
                            <div class="currencies-list__currency-media">
                                <img :src="'~/m/u/currencies/' + getCurrencyIsoName(rate) + '.png'" :alt="getCurrencyIsoName(rate)">
                            </div>
                            <div class="currencies-list__currency-info">
                                <p class="currencies-list__currency-name">
                                    {{ getCurrencyIsoName(rate) }}<span>&nbsp;&nbsp;{{ getCurrencyUnitAndName(rate.iso) }}</span>
                                </p>
                                <div class="currencies-list__currency-rate-change">
                                    <span class="currencies-list__currency-current-rate">{{ (rate.nbgOfficialRate || 0).toFixed(4) }}</span>
                                    <p class="currencies-list__currency-rate-state"
                                       :class="getNbgChangeClasses(rate)">
                                        <svg>
                                            <use xlink:href="~/m/i/icons.svg#symbol-chevron"></use>
                                        </svg>
                                        <span>{{ (rate.nbgOfficialRateChange || 0).toFixed(4) }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="currencies-list__rates">
                            <div class="currencies-list__rates-item">
                                <span class="currencies-list__rates-key">{{ $phrase('currencies_buy') }}</span>
                                <span class="currencies-list__rates-value">{{ getTeraCrossRate(rate.iso, "teraCrossRateBuy") }}</span>
                                <span class="currencies-list__rates-prev-value" v-if="showCurrencyPrevValue(rate.iso)">{{ getTeraCrossRate(rate.iso, "previousDayTeraCrossRateBuy") }}</span>
                            </div>
                            <div class="currencies-list__rates-item">
                                <span class="currencies-list__rates-key">{{ $phrase('currencies_sell') }}</span>
                                <span class="currencies-list__rates-value">{{ getTeraCrossRate(rate.iso, "teraCrossRateSell") }}</span>
                                <span class="currencies-list__rates-prev-value" v-if="showCurrencyPrevValue(rate.iso)">{{ getTeraCrossRate(rate.iso, "previousDayTeraCrossRateSell") }}</span>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('form-auto-loan', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendAutoLoanForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'AUTO_LOAN_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["auto-loan-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateAutoLoanForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('autoloanform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="auto-loan-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-business-loan', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendBusinessForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('vacancyId', window._data.currentVacancyId);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'BUSINESS_CARD_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["vacancy-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });


                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateBusinessLoanForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title" v-if="data.formSettings.title && data.formSettings.title.length">{{data.formSettings.title}}</h4>
            <p class="fill-application__item-subtitle" v-if="data.formSettings.content && data.formSettings.content.length" v-html="data.formSettings.content"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('businessloanform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="vacancy-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-contact', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            //submitForm(token)
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendContactForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'CONTACTFORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["contact-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });

                            }
                        });
                    }
                });
            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateContactForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            },
            //verifyCaptcha() {
            //    var _this = this;
            //    grecaptcha.ready(() => {
            //        grecaptcha
            //            .execute(window._data.reCaptchaSiteKey, {
            //                action: "submit"
            //            })
            //            .then(token => {
            //                _this.submitForm(token);
            //            });
            //    });
            //}
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small" @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('contactform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="contact-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-deposit', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendDepositForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'DEPOSIT_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["deposit-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });
            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateDepositForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('depositform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="deposit-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-general', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendGeneralForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'GENERAL_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["general-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });
            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateGeneralForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('generalform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="general-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-ipo-loan-for-immigrants', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendIpoLoanFormForImmigrants';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'IPO_LOAN_FOR_IMMIGRANTS_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["ipo-loan-form-for-immigrants-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateIpoLoanFormForImmigrants';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('ipoloanformforimmigrants_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="ipo-loan-form-for-immigrants-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-ipo-loan', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendIpoLoanForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'IPO_LOAN_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["ipo-loan-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateIpoLoanForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('ipoloanform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="ipo-loan-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-offer-for-legal-entities', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendOfferForLegalEntitiesForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'OFFER_FOR_LEGAL_ENTITIES_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["offer-for-legal-entities-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateOfferForLegalEntitiesForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('offerforlegalentitiesform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="offer-for-legal-entities-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-salary-port-out', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendSalaryPortOutForm'
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'SALARY_PORT_OUT_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["salary-port-out-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateSalaryPortOutForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('salaryportoutform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="salary-port-out-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-salary', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendSalaryForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'SALARY_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["auto-loan-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateSalaryForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title" v-if="data.formSettings.title && data.formSettings.title.length">{{data.formSettings.title}}</h4>
            <p class="fill-application__item-subtitle" v-if="data.formSettings.content && data.formSettings.content.length" v-html="data.formSettings.content"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('salaryform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="auto-loan-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-select', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendSelectForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'SELECT_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["select-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateSelectForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('contactform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="select-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-subscribe', {
        props: {},
        data: function () {
            return {
                data: {
                    email: ''
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            //submitForm(token)
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;

                _this.$nextTick(() => {

                    _this.settings.sendingData = true;
                    //formData.append('captcha', token);


                    var endPoint = 'SendSubscribeForm';
                    var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;


                    _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                        if (reCaptchaToken) {

                            let formData = new FormData();
                            formData.append('email', _this.data.email);
                            formData.append('langAbbr', window._data.languageAbbr);
                            formData.append('reCaptchaToken', reCaptchaToken);

                            axios.post(apiUrl, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                            ).then(function (response) {
                                _this.settings.succeeded = response.data.succeeded;
                                _this.settings.resultMessage = response.data.message;
                                _this.settings.sendingData = false;
                                if (response.data.succeeded) {
                                    _this.settings.submitted = false;

                                    (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'SUBSCRIBEFORM' });
                                }
                                Fancybox.show([{ src: _this.$refs["subscribe-form-dialog-alert"], type: "inline" }]);
                            }).catch(function (e) {
                                _this.settings.sendingData = false;
                            }).finally(function (e) {
                                _this.settings.sendingData = false;
                            });

                        }
                    });





                });
            },
        },

        mounted() {
        }
    ,
template: `
    <div class="subscribe">
        <div class="subscribe__content">
            <input type="text" :placeholder="$phrase('footer_subscribtionplaceholder')" class="subscribe__field"
                   v-model="data.email"
                   @keyup.enter="submitForm()" />
            <a href="" class="subscribe__action" @click.prevent="submitForm()"
               :class="{'loading':  settings.sendingData}">
                <svg class="subscribe__icon" v-if="!settings.sendingData">
                    <use xlink:href="~/m/i/icons.svg#symbol-plane"></use>
                </svg>
                <div class="spinner" v-if="settings.sendingData"></div>
            </a>
        </div>
    </div>
    <div class="form__message-dialog" ref="subscribe-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-tera-leasing-verification', {
        props: {},
        data: function () {
            return {
                form: {
                    selectedUserType: 0,
                    identityCode: '',
                    contactPersonFullname: '',
                    contactPersonIdentityCode: '',
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            selectUserType(type) {
                this.form.selectedUserType = type;
            },
            resetForm() {
                this.form.selectedUserType = 0;
                this.form.identityCode = '';
                this.form.contactPersonFullname = '';
                this.form.contactPersonIdentityCode = '';
                this.settings.sendingData = false;
            },



            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;

                _this.$nextTick(() => {

                    if (_this.form.selectedUserType == 0) {
                        return;
                    }
                    if (_this.form.selectedUserType == 1 && _this.form.identityCode.length != 11) {
                        return;
                    }
                    if (_this.form.selectedUserType == 2 && (_this.form.identityCode.length != 9 || _this.form.contactPersonFullname.length == 0 || _this.form.contactPersonIdentityCode.length != 11)) {
                        return;
                    }


                    _this.settings.sendingData = true;
                    var endPoint = 'SendTeraLeasingVerificationForm';
                    var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                    _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                        if (reCaptchaToken) {

                            let formData = new FormData();

                            formData.append('userType', _this.form.selectedUserType);
                            formData.append('identityCode', _this.form.identityCode);
                            formData.append('contactPersonFullname', _this.form.contactPersonFullname);
                            formData.append('contactPersonIdentityCode', _this.form.contactPersonIdentityCode);

                            formData.append('langAbbr', window._data.languageAbbr);
                            formData.append('url', window._data.currentUrl);
                            formData.append('reCaptchaToken', reCaptchaToken);

                            axios.post(apiUrl, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                            ).then(function (response) {
                                _this.settings.succeeded = response.data.succeeded;
                                _this.settings.resultMessage = response.data.message;
                                _this.settings.sendingData = false;
                                if (response.data.succeeded) {
                                    _this.settings.submitted = false;
                                    /* _this.clearFields();*/
                                    (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'TERA_LEASING_VERIFICATION_FORM' });
                                    //setTimeout(function () {
                                    //    location.reload()
                                    //}, 2000);
                                }
                                Fancybox.show([{ src: _this.$refs["tera-leasing-verification-form-dialog-alert"], type: "inline" }]);
                            }).catch(function (e) {
                                _this.settings.sendingData = false;
                            }).finally(function (e) {
                                _this.settings.sendingData = false;
                            });
                        }
                    });
                });

            },


            allowNumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 43) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
        },

        mounted() {
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title" v-if="getFormTitle().length">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-if="getFormSubTitle().length" v-html="getFormSubTitle()"></p>
        </div>

        <div class="fill-application__intro" v-if="form.selectedUserType == 0">
            <h4 class="fill-application__intro-title">{{ $phrase('teraleasingverificationform_choosetype') }}</h4>
            <div class="fill-application__intro-content">
                <a href="#" class="fill-application__intro-item" @click.prevent="selectUserType(1)">
                    <div class="fill-application__intro-item-media">
                        <svg class="fill-application__intro-item-icon fill-application__intro-item-icon--user">
                            <use xlink:href="~/m/i/icons.svg#symbol-user"></use>
                        </svg>
                    </div>
                    <h4 class="fill-application__intro-item-title">{{ $phrase('teraleasingverificationform_typephysical') }}</h4>
                </a>
                <a href="#" class="fill-application__intro-item" @click.prevent="selectUserType(2)">
                    <div class="fill-application__intro-item-media">
                        <svg class="fill-application__intro-item-icon fill-application__intro-item-icon--suitcase">
                            <use xlink:href="~/m/i/icons.svg#symbol-suitcase"></use>
                        </svg>
                    </div>
                    <h4 class="fill-application__intro-item-title">{{ $phrase('teraleasingverificationform_typelegal') }}</h4>
                </a>
            </div>
        </div>


        <div class="fill-application__form" v-if="form.selectedUserType > 0">
            <div class="form form--hw">

                <div class="form__section">
                    <div class="form__section-content" v-if="form.selectedUserType == 1">

                        <div class="form-group form-group--fw"
                             :class="{'has-error' : form.identityCode.length != 11 && submitted}">
                            <div class="form-group__content">
                                <input type="text"
                                       class="form__field"
                                       v-model="form.identityCode"
                                       v-on:keypress="allowNumbersOnly"
                                       maxlength="11"
                                       :placeholder="$phrase('teraleasingverificationform_physicalidentitycode')">
                                <label for="" class="form__label">{{ $phrase('teraleasingverificationform_physicalidentitycode') }}</label>
                            </div>
                            <!--<p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>-->
                        </div>

                    </div>

                    <div class="form__section-content" v-if="form.selectedUserType == 2">

                        <div class="form-group form-group--fw"
                             :class="{'has-error' : form.identityCode.length != 9 && submitted}">
                            <div class="form-group__content">
                                <input type="text"
                                       class="form__field"
                                       v-model="form.identityCode"
                                       v-on:keypress="allowNumbersOnly"
                                       maxlength="9"
                                       :placeholder="$phrase('teraleasingverificationform_legalidentitycode')">
                                <label for="" class="form__label">{{ $phrase('teraleasingverificationform_legalidentitycode') }}</label>
                            </div>
                            <!--<p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>-->
                        </div>

                        <div class="form-group form-group--fw"
                             :class="{'has-error' : form.contactPersonFullname.length <= 0 && submitted}">
                            <div class="form-group__content">
                                <input type="text"
                                       class="form__field"
                                       v-model="form.contactPersonFullname"
                                       :placeholder="$phrase('teraleasingverificationform_contactpersonfullname')">
                                <label for="" class="form__label">{{ $phrase('teraleasingverificationform_contactpersonfullname') }}</label>
                            </div>
                            <!--<p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>-->
                        </div>

                        <div class="form-group form-group--fw"
                             :class="{'has-error' : form.contactPersonIdentityCode.length != 11 && submitted}">
                            <div class="form-group__content">
                                <input type="text"
                                       class="form__field"
                                       v-model="form.contactPersonIdentityCode"
                                       v-on:keypress="allowNumbersOnly"
                                       maxlength="11"
                                       :placeholder="$phrase('teraleasingverificationform_contactpersonidentitycode')">
                                <label for="" class="form__label">{{ $phrase('teraleasingverificationform_contactpersonidentitycode') }}</label>
                            </div>
                            <!--<p v-if="!field.valid && submitted" class="form__error">{{ field.message }}</p>-->
                        </div>

                    </div>


                </div>


                <div class="form__section" v-if="form.selectedUserType > 0">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content form-group__content--space-between">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData, 'disabled' : ((form.selectedUserType == 1 && form.identityCode.length != 11) || form.selectedUserType == 2 && (form.identityCode.length != 9 || form.contactPersonFullname.length == 0 || form.contactPersonIdentityCode.length != 11) )}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('teraleasingverificationform_acceptbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                                <a href="" class="button button--primary-reverse button--small" @click.prevent="resetForm()">
                                    <span class="button__text">{{ $phrase('teraleasingverificationform_backbuttontitle') }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="tera-leasing-verification-form-dialog-alert" style="display: none;max-width:70rem">
        <div class="form__message "
             :class="{'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap" v-if="!settings.succeeded">
                <svg class="form__message-icon">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <!--<svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>-->
            </div>
            <p class="form__message-text" v-html="settings.resultMessage"></p>
            <div class="form__message-copy" v-show="settings.succeeded">
                <span class="form__message-copy-text">{{ $phrase('teraleasingverificationform_resultmessageiban') }}</span>
                <svg class="form__message-copy-icon">
                    <use xlink:href="~/m/i/icons.svg#symbol-copy"></use>
                </svg>
            </div>
        </div>
    </div>

`
});
Vue.component('form-tera-leasing', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendTeraLeasingForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'TERA_LEASING_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["auto-loan-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateTeraLeasingForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title" v-if="getFormTitle().length">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-if="getFormSubTitle().length" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>
                <!--<div class="form-group form-group--fw">
                    <div class="form-group__content">
                        <div class="recaptcha">
                            <p class="recaptcha__text">საიტი დაცულია Google და reCAPTCHA-ს მიერ. გაეცანით <a href="">კონფიდენციალურობის პოლიტიკასა</a> და <a href="">გამოყენების წესებს.</a></p>
                        </div>
                    </div>
                </div>-->
                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('teraleasingform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="auto-loan-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-travel-card', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            getFormTitle() {
                return window.form_title;
            },
            getFormSubTitle() {
                return window.form_subtitle;
            },
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;

                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendTravelCardForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('reCaptchaToken', reCaptchaToken);

                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'TRAVEL_CARD_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["travel-card-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.id + '||' + item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateTravelCardForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{getFormTitle()}}</h4>
            <p class="fill-application__item-subtitle" v-html="getFormSubTitle()"></p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('travelcardform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="travel-card-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('form-vacancy-application', {
        props: {},
        data: function () {
            return {
                data: {
                    formSettings: {},
                    branches: []
                },
                settings: {
                    submitted: false,
                    succeeded: false,
                    resultMessage: '',
                    sendingData: false
                },
            }
        },

        methods: {
            submitForm() {
                var _this = this;
                _this.settings.submitted = true;
                _this.validateAllFields();

                _this.$nextTick(() => {
                    if (_this.validateAllFields()) {
                        _this.settings.sendingData = true;

                        var endPoint = 'SendVacancyForm';
                        var apiUrl = window._data.apiBaseUrl + 'OnlineFormsApi/' + endPoint;

                        _this.$security.getGoogleReCaptchaToken(endPoint).then(function (reCaptchaToken) {
                            if (reCaptchaToken) {

                                let formData = _this.createFormData()
                                formData.append('langAbbr', window._data.languageAbbr);
                                formData.append('url', window._data.currentUrl);
                                formData.append('vacancyId', window._data.currentVacancyId);
                                formData.append('reCaptchaToken', reCaptchaToken);


                                axios.post(apiUrl, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(function (response) {
                                    _this.settings.succeeded = response.data.succeeded;
                                    _this.settings.resultMessage = response.data.message;
                                    _this.settings.sendingData = false;
                                    if (response.data.succeeded) {
                                        _this.settings.submitted = false;
                                        /* _this.clearFields();*/
                                        (window.dataLayer = window.dataLayer || []).push({ 'event': 'lead', 'category': 'application-form', 'type': 'VACANCY_FORM' });
                                        setTimeout(function () {
                                            location.reload()
                                        }, 2000);
                                    }
                                    Fancybox.show([{ src: _this.$refs["vacancy-form-dialog-alert"], type: "inline" }]);
                                }).catch(function (e) {
                                    _this.settings.sendingData = false;
                                }).finally(function (e) {
                                    _this.settings.sendingData = false;
                                });
                            }
                        });
                    }
                });

            },
            createFormData() {
                var _this = this;

                let formData = new FormData();

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];

                        if (item.hasOwnProperty('value') && item.value != null && item.value != undefined) {
                            if (item.type == 4) {
                                formData.append(item.id, item.value.title);
                            }
                            else if (item.type == 3) {
                                let filesArray = Array.isArray(item.value) ? item.value : [item.value];

                                filesArray.forEach((file, index) => {
                                    formData.append(`${item.id}`, file);
                                });
                            }
                            else {
                                formData.append(item.id, item.value);
                            }
                        }
                    }
                }

                return formData;
            },

            clearFields() {
                var _this = this;
                for (const key in _this.data.formSettings.groups) {
                    var group = _this.data.formSettings.groups[key];
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        _this.$nextTick(() => {
                            item.value = "";
                            _this.$refs.genericFormGroup.group = group;
                        });
                    }

                }
            },

            validateAllFields() {
                var _this = this;

                for (const key in _this.data.formSettings.groups) {
                    for (const field in _this.data.formSettings.groups[key].fields) {
                        let item = _this.data.formSettings.groups[key].fields[field];
                        if (item.hasOwnProperty('mandatory')) {
                            if (item.mandatory && !item.valid) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            populateForm() {
                var _this = this;

                var endpointUrl = window._data.apiBaseUrl + 'OnlineFormsApi/PopulateVacancyForm';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.data.formSettings = response.data.data.form;
                        }
                    }).catch(function (e) {
                    }).finally(function (e) {
                    });
            }
        },

        mounted() {
            this.populateForm();
        }
    ,
template: `
    <div class="fill-application__item">
        <div class="fill-application__item-text">
            <h4 class="fill-application__item-title">{{data.formSettings.title}}</h4>
            <p class="fill-application__item-subtitle">{{data.formSettings.content}}</p>
        </div>
        <br />
        <div class="fill-application__form">
            <div class="form">

                <generic-form-group v-for="group in data.formSettings.groups" :group="group" :submitted="settings.submitted"></generic-form-group>

                <div class="form__section">
                    <div class="form__section-content">
                        <div class="form-group form-group--fw">
                            <div class="form-group__content">
                                <a href="" class="button button--primary button--small " @click.prevent="submitForm()"
                                   :class="{'loading':  settings.sendingData}">
                                    <!--disabled-->
                                    <span class="button__text">{{ $phrase('vacancyform_sendbuttontitle') }}</span>
                                    <div class="spinner"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form__message-dialog" ref="vacancy-form-dialog-alert" style="display: none;">
        <div class="form__message "
             :class="{'form__message--success' : settings.succeeded, 'form__message--error' : !settings.succeeded}">
            <div class="form__message-icon-wrap">
                <svg class="form__message-icon" v-if="!settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-exclamation"></use>
                </svg>
                <svg class="form__message-icon" v-if="settings.succeeded">
                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox"></use>
                </svg>
            </div>
            <p class="form__message-text">{{settings.resultMessage}}</p>
        </div>
    </div>

`
});
Vue.component('generic-form-field', {
        props: {
            field: Object,
            submitted: Boolean,
            relatedField: Object
        },
        data: function () {
            return {
                data: {
                },
                settings: {
                    submitted: false
                },
            };
        },
        methods: {

        },
        mounted() {

        }

    ,
template: `
    <formcontrol-text-input :field="field" :submitted="submitted" v-if="field.type == 0"></formcontrol-text-input>
    <formcontrol-number-input :field="field" :submitted="submitted" v-if="field.type == 1"></formcontrol-number-input>
    <formcontrol-textarea-input :field="field" :submitted="submitted" v-if="field.type == 2"></formcontrol-textarea-input>
    <formcontrol-file-upload :field="field" :submitted="submitted" v-if="field.type == 3"></formcontrol-file-upload>
    <formcontrol-select :field="field" :related-field="relatedField" :submitted="submitted" v-if="field.type == 4"></formcontrol-select>
    <formcontrol-recaptcha :field="field" :related-field="relatedField" :submitted="submitted" v-if="field.type == 5"></formcontrol-recaptcha>
`
});
Vue.component('generic-form-group', {
        props: {
            group: Object,
            submitted: Boolean,
        },
        data: function () {
            return {
            };
        },
        methods: {
            getRelatedField(field) {
                var relatedField = this.group.fields.find(f => f.id == field.refId);

                return relatedField;
            }
        },
        mounted() {

        }
    ,
template: `
    <div class="form__section">
        <h4 class="form__section-title" v-if="group.title">{{group.title}}</h4>
        <div class="form__section-content">
            <generic-form-field v-for="field in group.fields"
                                :field="field"
                                :submitted="submitted"
                                :related-field="getRelatedField(field)">
            </generic-form-field>
        </div>
    </div>
`
});
document
    .querySelectorAll('[data-vueapp]')
    .forEach(element => {
        window._createVueApp(element);
    });

function matchMediaQuery(query) {
    try {
        return window.matchMedia(query).matches;
    }
    catch (err) {
        return false;
    }
}

(function initializeMenu() {
    var setupMenu = function (menuElems, mainContainerWidthPx, moreContainerParent, moreContainer, widthSubtractPx, additionalWidthPx) {
        var currentWidthPx = widthSubtractPx + additionalWidthPx;
        var visibleItems = [];
        var invisibleItems = [];
        moreContainerParent.hide();

        const menuWrapper = document.getElementsByClassName('arrange-not-initialized');

        if (menuWrapper != null) {
            $(menuWrapper).removeClass('arrange-not-initialized');
        }

        for (let i = 0; i < menuElems.length; i++) {
            var currentItem = menuElems.eq(i);
            var currElemWidth = currentItem.outerWidth(true) + additionalWidthPx;
            currentWidthPx += currElemWidth;

            if (currentWidthPx >= mainContainerWidthPx) {
                invisibleItems.push(currentItem);
                moreContainerParent.show();
            } else {
                visibleItems.push(currentItem);
            }
        }
        menuElems.hide();
        $(visibleItems).each(function () {
            $(this).show();
        });

        $(moreContainer).empty();

        $(invisibleItems).each(function () {
            var $clone = $(this).find('a').clone();
            $(moreContainer).append($clone);
        });

    }

    var arrangeMenu = function () {
        if (matchMediaQuery("(min-width: 768px)")) {
            var $singleMenuItems = $('.menu .menu-item.singleitem');
            var $containerWidthPx = $('.header-main .container .header-main__content').width() - 200;
            var $dropdownContainer = $('.menu .menu-item.dropdown-holder .dropdown');
            var $moreContainerParent = $('.menu .menu-item.dropdown-holder');
            var $minWidthSubtractPx = $('.menu-item.dropdown-holder').outerWidth(true);
            setupMenu($singleMenuItems, $containerWidthPx, $moreContainerParent, $dropdownContainer, $minWidthSubtractPx, 60);
        } else {
            return false;
        }
    };

    $(window).on('resize', function () {
        arrangeMenu();
    });
    $(function () {
        arrangeMenu();
    });
    setTimeout(function () {
        arrangeMenu();
    }, 100);
    arrangeMenu();

    $(".table").wrap("<div class='table-responsive'></div>");

})();

setTimeout(function () {
    svg4everybody();
    (function () {
        $('.js-trigger').on('click', function () {
            var _trigger = $(this);
            var _results = $(this).siblings('.js-results');
            _trigger.parent().toggleClass('open');
            _results.stop().slideToggle('fast');
            $('.js-trigger').not(_trigger).parent().removeClass('open');
            $('.js-results').not(_results).slideUp('fast');
            return false;
        });

        $('.compare__product--empty').on('click', function () {
            $(this.querySelector('.js-trigger')).trigger('click')
        });

        let showTimeout;
        $('.menu-item.has-dropdown').hover(
            function () {
                showTimeout = setTimeout(() => {
                    $(this).find('.submenu-wrap').toggleClass('open', true)
                    $('body').toggleClass('menu-open', true);
                }, 150);
            },
            function () {
                clearTimeout(showTimeout);
                $(this).find('.submenu-wrap').toggleClass('open', false);
                $('body').toggleClass('menu-open', false);
            }
        );

        let initializeSectionSwiper = function (sliderClass, slidesperView, slidesPerViewSmallDesktop, spacebetween) {
            const slider = new Swiper(sliderClass + ' .swiper', {
                slidesPerView: 'auto',
                spaceBetween: 16,
                watchOverflow: true,
                navigation: {
                    disabledClass: 'swiper__button--disabled',
                    nextEl: sliderClass + ' .swiper__button--next',
                    prevEl: sliderClass + ' .swiper__button--prev',
                },
                pagination: false,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: slidesPerViewSmallDesktop,
                        spaceBetween: spacebetween,
                    },
                    1432: {
                        slidesPerView: slidesperView,
                    }
                }
            })
        }

        initializeSectionSwiper('.news-slider', 3, 3, 24);
        initializeSectionSwiper('.blog-slider', 2, 3, 24);
        initializeSectionSwiper('.products-slider', 3, 3, 24);
        initializeSectionSwiper('.money-transfers-slider', 4, 3, 24);
        initializeSectionSwiper('.services-slider', 3, 3, 24);
        initializeSectionSwiper('.offers-slider', 3, 3, 24);
        initializeSectionSwiper('.developer-offers-slider', 4, 3, 24);
        initializeSectionSwiper('.accredited-universities-slider', 4, 3, 24);
        initializeSectionSwiper('.detail-services-slider', 2, 2, 24);
        initializeSectionSwiper('.detail-products-slider', 2, 2, 24);
        initializeSectionSwiper('.select-offers-slider', 3, 3, 24);
        initializeSectionSwiper('.page-gallery-slider', 3, 3, 24);

        initializeSectionSwiper('.page-main--short .products-slider', 2, 2, 24);
        initializeSectionSwiper('.page-main--short .services-slider', 2, 2, 24);
        initializeSectionSwiper('.page-main--short .offers-slider', 2, 2, 24);
        initializeSectionSwiper('.page-main--short .select-offers-slider', 2, 2, 24);
        initializeSectionSwiper('.page-main--short .news-slider', 2, 2, 24);
        initializeSectionSwiper('.page-main--short .money-transfers-slider', 3, 2, 24);

        $('.expand-table').on('click', function () {
            $(this).toggleClass('open');
            $(this).parents('.key-value-table').toggleClass('expanded');
            return false;
        })

        $('.js-loan-compare-trigger').on('click', function (e) {
            UiService.shared.dispatchOpenCompareModalEvent('loan', e.target.dataset.id)
            e.preventDefault();
            return false;
        })

        $('.js-deposit-compare-trigger').on('click', function (e) {
            UiService.shared.dispatchOpenCompareModalEvent('deposit', e.target.dataset.id)
            e.preventDefault();
            return false;
        })

        $('.js-card-compare-trigger').on('click', function (e) {
            UiService.shared.dispatchOpenCompareModalEvent('card', e.target.dataset.id)
            e.preventDefault();
            return false;
        })

        //$('.js-compare-close').on('click', function () {
        //    $('.js-compare-results').hide();
        //    $('body').toggleClass('noscroll', false);
        //    return false;
        //});

        $('.footer-main__column-head').on('click', function () {
            if ($(window).width() <= 767) {
                $('.footer-main__column-list').not($(this).siblings('.footer-main__column-list')).slideUp();
                $('.footer-main__column-head').not($(this)).toggleClass('open', false);
                $(this).toggleClass('open');
                $(this).siblings('.footer-main__column-list').slideToggle();
            }
        });

        // Add copy functionality for form message
        const handleCopy = () => {
            const copyButtons = document.querySelectorAll('.form__message-copy');

            copyButtons.forEach(button => {
                button.addEventListener('click', function () {
                    const textElement = this.querySelector('.form__message-copy-text');
                    const textToCopy = textElement.textContent;

                    // Copy text to clipboard
                    navigator.clipboard.writeText(textToCopy).then(() => {
                        // Create and show "Copied" message
                        const copiedText = document.createElement('span');
                        copiedText.className = 'form__message-copy-status';
                        copiedText.textContent = 'Copied';

                        // Add the element after the copy icon
                        this.appendChild(copiedText);

                        // Remove the message after 3 seconds
                        setTimeout(() => {
                            copiedText.remove();
                        }, 3000);
                    });
                });
            });
        };

        handleCopy();

    })();

    if (document.getElementById("inpage-nav")) {
        function whereToFixHeight() {
            var navbar = document.getElementById('inpage-nav');
            var header = document.getElementById('header');
            return navbar.offsetHeight + header.offsetHeight;
        }

        function updateActiveNavItem() {
            var sections = document.querySelectorAll('.scrollable-section');
            var navLinks = document.querySelectorAll('.inpage-nav__item');

            var currentSectionId = '';
            sections.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.offsetHeight;

                if (window.scrollY >= (sectionTop - sectionHeight / 3) &&
                    window.scrollY < (sectionTop + sectionHeight)) {
                    currentSectionId = section.getAttribute('id');
                }
            });

            navLinks.forEach(link => {
                link.classList.remove('active');
                if (link.getAttribute('href') === '#' + currentSectionId) {
                    link.classList.add('active');
                }
            });
        }

        // Event listener for making navbar fixed and updating active links on scroll
        let lastScrollTop = 0;
        window.addEventListener('scroll', function () {
            var navbarPlaceholder = document.querySelector('.inpage-nav-wrap');
            var navbar = document.getElementById('inpage-nav');
            var header = document.getElementById('header');
            var navbarPlaceholderMarginBottom = parseInt(window.getComputedStyle(navbarPlaceholder).marginBottom);
            var navbarPlaceholderOffsetTop = navbarPlaceholder.offsetTop - navbarPlaceholderMarginBottom;
            var fixedPoint = navbar.offsetTop - header.offsetHeight;
            var scrollingUp = window.scrollY < lastScrollTop;


            if (!scrollingUp) {
                if (window.scrollY > fixedPoint) {
                    navbar.classList.add('fixed');
                    navbarPlaceholder.classList.add('fixed');
                }
            }
            else {
                if (window.scrollY <= navbarPlaceholderOffsetTop) {
                    navbar.classList.remove('fixed');
                    navbarPlaceholder.classList.remove('fixed');
                }
            }

            updateActiveNavItem();
            lastScrollTop = window.scrollY;
        });

        // Event listener for smooth scrolling and updating active links on click
        document.querySelectorAll('.inpage-nav__item').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                document.querySelectorAll('.inpage-nav__item').forEach(el => el.classList.remove('active'));

                this.classList.add('active');

                const sectionId = this.getAttribute('href');
                const section = document.querySelector(sectionId);
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                const minusScrollHeight = whereToFixHeight();
                window.scrollTo({
                    top: sectionTop - minusScrollHeight - 20,
                    behavior: 'smooth'
                });
            });
        });
    }


    window.addEventListener('scroll', function () {
        var targetDiv = document.getElementById('header-app');
        var scrollPosition = window.scrollY;
        var targetDivHeight = targetDiv.offsetHeight;

        if (scrollPosition > targetDivHeight) {
            targetDiv.classList.add('scrolled-past');
        } else {
            targetDiv.classList.remove('scrolled-past');
        }
    });

    window.onscroll = function () { stickyBottomNav() };

    function stickyBottomNav() {
        var footer = document.querySelector('.footer');
        var bottomNav = document.getElementById('bottom-navigation');

        var footerPosition = footer.getBoundingClientRect().top;
        var windowHeight = window.innerHeight;

        if (footerPosition < windowHeight) {
            document.body.style.paddingBottom = bottomNav.offsetHeight + 'px';
        } else {
            document.body.style.paddingBottom = '0';
        }
    }

    document.querySelector('.js-expand-bottom-nav').addEventListener('click', function (e) {

        e.preventDefault();

        const dropdownContent = document.querySelector('.js-bottom-nav-leftover');

        const headerHeight = document.querySelector('.header').offsetHeight;
        const bottomNavHeight = document.querySelector('.bottom-navigation').offsetHeight;
        const screenHeight = window.innerHeight;
        const dropdownHeight = screenHeight - headerHeight - bottomNavHeight;

        if (dropdownContent.classList.contains('active')) {
            dropdownContent.style.height = 0;
            dropdownContent.classList.remove('active');
            setTimeout(function () {
                dropdownContent.style.transform = 'translateY(100%)';
                document.body.classList.remove('noscroll');
            }, 300);
        } else {
            dropdownContent.style.transform = 'translateY(0)';
            setTimeout(function () {
                dropdownContent.classList.add('active');
                dropdownContent.style.height = dropdownHeight + 'px';
                document.body.classList.add('noscroll');
            }, 10);
        }
    });

    if (document.querySelectorAll(".page-actions")) {
        document.querySelectorAll('.page-actions').forEach(parent => {
            if (parent.childElementCount === 1) {
                parent.style.justifyContent = 'center';
            } else {
                parent.style.justifyContent = 'space-between';
            }
        });
    };



    // Function to check if screen width is >= 1200px
    const isDesktop = () => window.innerWidth >= 1200;

    // Wrap all the functionality in a function
    const initializePackagesGrid = () => {
        const gridContent = document.querySelector('.packages-grid');
        const packagesNavPrevButton = document.querySelector('.packages-grid__nav--prev');
        const packagesNavNextButton = document.querySelector('.packages-grid__nav--next');

        // Only proceed if the elements exist
        if (!gridContent || !packagesNavPrevButton || !packagesNavNextButton) return;

        const COLUMN_WIDTH = 320;
        const COLUMN_GAP = 16;

        packagesNavPrevButton.style.opacity = '0';
        packagesNavNextButton.style.opacity = '0';

        const updateButtonHeight = () => {
            const firstRowCell = document.querySelector('.packages-grid__head .packages-grid__cell');
            if (firstRowCell) {
                const cellHeight = firstRowCell.offsetHeight;
                packagesNavPrevButton.style.height = `${cellHeight}px`;
                packagesNavNextButton.style.height = `${cellHeight}px`;
                updatePackageNavButtonVisibility();
            }
        };

        const getGridDimensions = () => {
            const headerRow = document.querySelector('.packages-grid__head .packages-grid__row');
            if (!headerRow) return { numberOfColumns: 0, frozenColumnWidth: 0 };

            const frozenColumn = headerRow.querySelector('.packages-grid__cell--frozen');
            const frozenColumnWidth = frozenColumn ? frozenColumn.offsetWidth : 0;
            const headerCells = headerRow.querySelectorAll('.packages-grid__cell:not(.packages-grid__cell--frozen)');

            return {
                numberOfColumns: headerCells.length,
                frozenColumnWidth: frozenColumnWidth
            };
        };

        const getTotalGridWidth = () => {
            const { numberOfColumns, frozenColumnWidth } = getGridDimensions();
            return frozenColumnWidth + COLUMN_GAP + (numberOfColumns * COLUMN_WIDTH) + ((numberOfColumns - 1) * COLUMN_GAP);
        };

        const updatePackageNavButtonVisibility = () => {
            const scrollLeft = gridContent.scrollLeft;
            const visibleWidth = gridContent.clientWidth;
            const totalWidth = getTotalGridWidth();
            const maxScroll = totalWidth - visibleWidth;
            const remainingScroll = maxScroll - scrollLeft;

            packagesNavPrevButton.style.display = scrollLeft <= 0 ? 'none' : 'flex';
            packagesNavPrevButton.style.opacity = scrollLeft <= 0 ? '0' : '1';

            packagesNavNextButton.style.display = remainingScroll <= (COLUMN_WIDTH / 2) ? 'none' : 'flex';
            packagesNavNextButton.style.opacity = remainingScroll <= (COLUMN_WIDTH / 2) ? '0' : '1';
        };

        const scrollPackagesGrid = (direction) => {
            const scrollLeft = gridContent.scrollLeft;
            const visibleWidth = gridContent.clientWidth;
            const totalWidth = getTotalGridWidth();
            const maxScroll = totalWidth - visibleWidth;
            const remainingScroll = maxScroll - scrollLeft;

            if (direction === 'next') {
                // Only scroll if there's meaningful content left to show
                if (remainingScroll > COLUMN_WIDTH / 2) {
                    gridContent.scrollBy({
                        left: COLUMN_WIDTH + COLUMN_GAP,
                        behavior: 'smooth'
                    });
                }
            } else {
                gridContent.scrollBy({
                    left: -(COLUMN_WIDTH + COLUMN_GAP),
                    behavior: 'smooth'
                });
            }
        };

        // Reset on resize
        const handleGridResize = () => {
            updatePackageNavButtonVisibility();
        };

        packagesNavPrevButton.addEventListener('click', () => scrollPackagesGrid('prev'));
        packagesNavNextButton.addEventListener('click', () => scrollPackagesGrid('next'));
        gridContent.addEventListener('scroll', updatePackageNavButtonVisibility);
        window.addEventListener('resize', handleGridResize);

        // Initial button visibility
        updateButtonHeight();
    };

    // Function to handle initialization and cleanup
    const handleResize = () => {
        if (isDesktop()) {
            initializePackagesGrid();
        } else {
            // Clean up for smaller screens if needed
            const packagesNavPrevButton = document.querySelector('.packages-grid__nav--prev');
            const packagesNavNextButton = document.querySelector('.packages-grid__nav--next');

            if (packagesNavPrevButton) packagesNavPrevButton.style.display = 'none';
            if (packagesNavNextButton) packagesNavNextButton.style.display = 'none';
        }
    };

    // Initial check and setup
    handleResize();

    // Update on window resize
    window.addEventListener('resize', handleResize);

}, 200);

class DarkModeService {
    constructor() {
        this._darkModeStorageParamName = 'darkmode'
        this._darkModeCssClassName = 'dark-theme'
        this._isEnabled = false

        this._init()
    }

    isEnabled() {
        return this._isEnabled
    }

    setDarkMode(enable) {
        this._isEnabled = enable

        var darkModeStorageValue = this._isEnabled ? '1' : '0'
        localStorage.setItem(this._darkModeStorageParamName, darkModeStorageValue)

        document.body.classList.toggle(this._darkModeCssClassName, this._isEnabled)
        this._updateImages()
    }

    _updateImages() {
        const isDarkMode = document.body.classList.contains(this._darkModeCssClassName)
        const images = document.querySelectorAll('img[data-dark-src]')

        images.forEach(img => {
            const lightSrc = img.getAttribute('src');
            const darkSrc = img.getAttribute('data-dark-src');

            if (isDarkMode) {
                // Store the light src if not already stored
                if (!img.hasAttribute('data-light-src')) {
                    img.setAttribute('data-light-src', lightSrc);
                }
                img.setAttribute('src', darkSrc);
                // Set opacity back to 1 after image loads
                img.onload = function () {
                    this.style.opacity = '1';
                };
            } else {
                img.setAttribute('src', img.getAttribute('data-light-src') || lightSrc);
            }
        })
    }

    _init() {
        document.addEventListener('DOMContentLoaded', () => {
            if (localStorage.getItem(this._darkModeStorageParamName) === '1') {
                document.body.classList.add(this._darkModeCssClassName)
            }

            this._updateImages();
        });

        setTimeout(() => {
            if (localStorage.getItem(this._darkModeStorageParamName) === '1') {
                this._isEnabled = true
                document.body.classList.add(this._darkModeCssClassName)
            }
            this._updateImages()
        }, 200);
    }
}

DarkModeService.shared = new DarkModeService();